import { t as xt } from "./module.esm-SeyKV0Gz.js";
import { t as mi } from "./queueBounce-BYbNS_fP.js";
import { t as Jt } from "./morphNodes-CORZXiqO.js";
import { n as gi, r as bi, t as yi } from "./searchStore-Db11t7wp.js";
var wi = {
  "x-transition:enter": "transition-opacity ease-linear duration-300",
  "x-transition:enter-start": "opacity-0",
  "x-transition:enter-end": "opacity-100",
  "x-transition:leave": "transition-opacity ease-linear duration-300",
  "x-transition:leave-start": "opacity-100",
  "x-transition:leave-end": "opacity-0"
}, je = {
  "x-transition:enter": "transition ease-in-out duration-300 transform",
  "x-transition:enter-start": "-translate-x-full",
  "x-transition:enter-end": "translate-x-0",
  "x-transition:leave": "transition ease-in-out duration-300 transform",
  "x-transition:leave-start": "translate-x-0",
  "x-transition:leave-end": "-translate-x-full"
}, xi = (t) => t.data("addressSwitch", ({ addresses: e }) => ({
  addresses: e,
  slideTransition: je,
  visibleForm: !1,
  currentlyEditedAddress: null,
  showForm() {
    this.visibleForm = !0;
  },
  editAddress(i) {
    this.visibleForm = !0, this.currentlyEditedAddress = this.addresses.find((n) => n.id === i), this.scrollFormIntoView();
  },
  cancelEdit() {
    this.visibleForm = !1, this.currentlyEditedAddress = null, this.scrollFormIntoView();
  },
  scrollFormIntoView() {
    window.matchMedia("(max-width: 1023px)").matches && document.querySelector(".address-form")?.scrollIntoView({ behavior: "smooth" });
  }
})), Ei = (t) => t.data("announcement", (e) => {
  const { settings: i } = e;
  return {
    current: 0,
    init() {
      i.auto_scroll && e.count > 0 && this.autoScroll(), this.$watch("current", (n) => this.autoScroll(n));
    },
    change(n) {
      this.current = n;
    },
    autoScroll(n = 0) {
      n >= e.count ? n = 0 : n += 1, setTimeout(() => this.change(n), i.delay * 1e3);
    },
    scrollThrough() {
      return {
        "x-transition:enter": "transition ease-in-out duration-300 transform absolute delay-300",
        "x-transition:enter-start": "-translate-y-full opacity-0",
        "x-transition:enter-end": "translate-y-0",
        "x-transition:leave": "transition ease-in-out duration-300 transform absolute",
        "x-transition:leave-start": "translate-y-0",
        "x-transition:leave-end": "translate-y-full opacity-0 "
      };
    }
  };
}), Si = (t) => {
  t.data("backInStock", (e, i) => ({
    open: !1,
    sending: !1,
    sent: !1,
    query: {
      a: "Mtd5NY",
      g: "",
      email: "",
      variant: i,
      product: e,
      platform: "shopify",
      subscribe_for_newsletter: !1
    },
    get emailIsValid() {
      return /.+@.+\..+/.test(this.query.email);
    },
    get buttonLabel() {
      return this.sending ? "Sending..." : this.sent ? "Sent!" : "Notify Me When Available";
    },
    async submit() {
      if (!this.query.email) return;
      const n = "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", r = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(this.query)
      };
      this.sending = !0;
      try {
        const a = await fetch(n, r);
        if (!a.ok) throw new Error("Failed to subscribe");
        if (!(await a.json()).success) throw new Error("Failed to subscribe");
      } catch (a) {
        console.error(a);
      }
      this.sending = !1, this.sent = !0, setTimeout(() => this.open = !1, 2e3);
    }
  }));
}, Ti = (t) => {
  t.data("cardBadges", (e) => ({
    product: e,
    badgeRules: [],
    matched: null,
    init() {
      this.badgeRules = JSON.parse(this.$el.querySelector("script[data-badges]")?.textContent ?? "[]");
    },
    badgeFieldValue(i) {
      const n = this.product.additional_data || {};
      for (const r of i.keys || []) {
        const a = n[r], s = Array.isArray(a) ? a.find((o) => String(o).trim() !== "") : a;
        if (s != null && String(s).trim() !== "") return String(s).trim();
      }
      return "";
    },
    badgeLabel(i) {
      if (i.kind === "tag") return (this.product.tags || []).map((r) => String(r).trim().toLowerCase()).includes(i.tag) ? i.label : null;
      if (i.kind === "sold_out") return this.product.available === !1 ? i.label : null;
      const n = this.badgeFieldValue(i);
      return n === "" || n === "false" || n === "0" ? null : i.kind === "metafield_text" ? n : i.label;
    },
    resolveBadge() {
      for (const i of this.badgeRules) {
        const n = this.badgeLabel(i);
        if (n) return {
          ...i,
          label: n
        };
      }
      return null;
    }
  }));
}, ot = (t, e) => e instanceof t ? e : null, ki = (t, e, i = 0) => Math.min(Math.max(t, i), e), St = {}, Ii = async (t) => {
  const e = t.toString();
  if (St[e]) return St[e];
  const i = await fetch(t);
  return i.ok ? (St[e] = await i.text(), St[e]) : null;
}, Ci = () => new Promise((t) => queueMicrotask(() => setTimeout(t, 0))), Ni = (t, e, i = 0) => (t - i) % (e - i) + i, Oi = 5e3, Li = (t) => t.data("cartDrawer", () => ({
  activeUpdates: 0,
  status: "",
  statusTimer: 0,
  giftDraft: null,
  init() {
    this.refresh = this.refresh.bind(this), this.updateItem = t.debounce(this.updateItem.bind(this), 500), this.$store.cart.addEventListener("open", this.refresh, { signal: this.$abortSignal }), this.$store.cart.addEventListener("load", this.refresh, { signal: this.$abortSignal });
  },
  async refresh() {
    const e = new URL(window.location.href), i = oe();
    this.activeUpdates++, e.searchParams.set("sections", i.join(","));
    const n = await fetch(e);
    if (i.length && --this.activeUpdates == 0) {
      const r = await n.json();
      Jt(Object.values(r).join(""), []);
    }
  },
  close() {
    this.$store.cart.close();
  },
  async postCart(e, i, n = {}) {
    const r = n.swap !== !1, a = r ? oe() : [];
    r && this.activeUpdates++;
    const s = await fetch(e, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(a.length ? {
        ...i,
        sections: a.join(",")
      } : i)
    }), o = await s.json().catch(() => ({}));
    if (!s.ok)
      throw r && this.activeUpdates--, new Error(String(o.description ?? o.message ?? s.statusText));
    return a.length && --this.activeUpdates == 0 && Jt(Object.values(o.sections ?? {}).join(""), []), o;
  },
  announce(e) {
    window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
      this.status = e, e && (this.statusTimer = window.setTimeout(() => {
        this.status = "";
      }, Oi));
    });
  },
  async removeItem(e) {
    await this.postCart("/cart/update.js", { updates: { [e]: 0 } });
  },
  async updateItem(e, i) {
    await this.postCart("/cart/update.js", { updates: { [e]: i } });
  },
  async changeItem(e, i) {
    await this.postCart("/cart/change.js", {
      id: e,
      properties: i
    });
  },
  async changeSellingPlan(e, i, n = 1) {
    await this.postCart("/cart/change.js", {
      id: e,
      selling_plan: i,
      quantity: n
    });
  }
})), oe = () => {
  const t = Array.from(document.querySelectorAll(".shopify-section:has([data-oob-swap])"), (e) => e?.id.replace("shopify-section-", "") ?? "");
  return Array.from(new Set(t));
};
var ct = (t, e) => t.replace(/\[(\w+)\]/g, (i, n) => Object.hasOwn(e, n) ? String(e[n]) : i), te = (t, e) => Object.fromEntries(t.map((i) => [i.key, (e[i.key] ?? "").trim()])), le = (t, e, i) => {
  const n = te(t, e), r = {};
  for (const a of t) {
    const s = n[a.key];
    a.required && s === "" ? r[a.key] = ct(i.requiredError, { label: a.label.toLowerCase() }) : a.limit > 0 && s.length > a.limit && (r[a.key] = ct(i.overLimitError, {
      label: a.label,
      count: s.length - a.limit,
      limit: a.limit
    }));
  }
  return r;
}, _i = (t) => Math.max(1, Math.floor(t * 0.1)), Ai = (t, e, i) => {
  const n = e - t.length;
  return n < 0 ? ct(i.charsOver, { count: -n }) : n <= _i(e) ? ct(i.charsRemainingLow, { count: n }) : ct(i.charsRemaining, { count: n });
}, Fi = (t, e) => {
  const i = te(t, e);
  return t.filter((n) => i[n.key] !== "").map((n) => `${n.label}: ${i[n.key]}`).join(`
`);
}, $i = (t) => Object.fromEntries(Object.entries(t).filter(([, e]) => e !== "")), Ri = (t, e, i) => {
  const n = te(t, e), r = {
    path: "/cart/update.js",
    swap: !0,
    body: {
      attributes: n,
      ...i.copyToNote ? { note: Fi(t, e) } : {}
    }
  };
  if (i.cardVariantId === null) return [r];
  const a = $i(n);
  return i.cardInCart && i.cardLineKey ? [{
    path: "/cart/change.js",
    swap: !1,
    body: {
      id: i.cardLineKey,
      quantity: i.cardQuantity,
      properties: a
    }
  }, r] : [{
    path: "/cart/add.js",
    swap: !1,
    body: { items: [{
      id: i.cardVariantId,
      quantity: 1,
      properties: a
    }] }
  }, r];
}, Di = (t, e, i = null) => ({
  path: "/cart/update.js",
  swap: !0,
  body: {
    ...e.cardVariantId !== null && e.cardInCart ? { updates: { [e.cardVariantId]: 0 } } : {},
    attributes: Object.fromEntries(t.map((n) => [n.key, i])),
    ...e.copyToNote ? { note: "" } : {}
  }
}), z = (t) => t, ce = () => !!window.Shopify?.designMode, Pi = (t) => t.data("cartGiftMessage", (e) => ({
  open: !1,
  editing: !e.saved,
  card: e.cardInCart,
  saving: !1,
  error: "",
  values: {},
  errors: {},
  fields: [],
  lastAnnounced: {},
  counterTimer: 0,
  init() {
    const i = Array.from(this.$root.querySelectorAll("[data-gm-field]"));
    this.fields = i.map((a) => ({
      key: a.dataset.key ?? "",
      label: a.dataset.label ?? "",
      required: a.dataset.required === "true",
      limit: Number(a.dataset.limit ?? 0)
    }));
    const n = Object.fromEntries(i.map((a) => [a.dataset.key ?? "", a.querySelector("input, textarea")?.value ?? ""])), r = z(this).giftDraft;
    this.values = {
      ...n,
      ...r?.values ?? {}
    }, this.open = r?.open ?? e.editorOpen, this.editing = r?.editing ?? !e.saved, this.card = e.cardInCart ? !0 : r?.card ?? !1, this.error = r?.error ?? "";
  },
  context() {
    return {
      cardVariantId: e.cardVariantId,
      cardInCart: e.cardInCart,
      cardLineKey: e.cardLineKey,
      cardQuantity: e.cardQuantity,
      copyToNote: e.copyToNote
    };
  },
  control(i) {
    return Array.from(this.$root.querySelectorAll("[data-gm-field]")).find((n) => n.dataset.key === i)?.querySelector("input, textarea") ?? null;
  },
  focusKey(i) {
    this.$root.querySelector(`[data-focus-key="${i}"]`)?.focus();
  },
  focusFirstField() {
    const i = this.fields.find((n) => !this.control(n.key)?.disabled);
    i && this.control(i.key)?.focus();
  },
  persist() {
    z(this).giftDraft = {
      open: this.open,
      editing: this.editing,
      card: this.card,
      values: { ...this.values },
      error: this.error
    };
  },
  clearDraft() {
    z(this).giftDraft = null;
  },
  toggle() {
    this.open = !this.open, this.persist();
  },
  collapse() {
    if (e.saved && this.editing) {
      this.editing = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-edit"));
      return;
    }
    this.open = !1, this.persist(), this.$nextTick(() => this.focusKey("gift-toggle"));
  },
  edit() {
    this.editing = !0, this.open = !0, this.persist(), this.$nextTick(() => this.focusFirstField());
  },
  onInput(i) {
    if (this.errors[i]) {
      const n = this.fields.find((a) => a.key === i), r = n ? le([n], this.values, e.strings) : {};
      if (r[i])
        this.errors = {
          ...this.errors,
          [i]: r[i]
        };
      else {
        const { [i]: a, ...s } = this.errors;
        this.errors = s;
      }
    }
    this.persist(), this.scheduleCounterAnnouncement(i);
  },
  onCardChange() {
    if (!this.card) {
      const i = this.$root.querySelector("fieldset"), n = document.activeElement;
      i && n && i.contains(n) && this.$root.querySelector('input[type="checkbox"]')?.focus();
    }
    this.persist();
  },
  counterText(i, n) {
    return Ai(this.values[i] ?? "", n, e.strings);
  },
  describedBy(i, n, r) {
    const a = [n, this.errors[i] ? r : ""].filter(Boolean);
    return a.length ? a.join(" ") : null;
  },
  scheduleCounterAnnouncement(i) {
    const n = this.fields.find((r) => r.key === i);
    !n || n.limit <= 0 || (window.clearTimeout(this.counterTimer), this.counterTimer = window.setTimeout(() => {
      const r = n.limit - (this.values[i] ?? "").length, a = r <= 0 ? 0 : r <= 20 ? 20 : -1;
      if (a < 0 || this.lastAnnounced[i] === a) {
        a < 0 && delete this.lastAnnounced[i];
        return;
      }
      this.lastAnnounced[i] = a, z(this).announce(a === 0 ? e.strings.limitReached : ct(e.strings.charsRemaining, { count: r }));
    }, 500));
  },
  async save() {
    if (ce() || this.saving) return;
    this.error = "", this.errors = le(this.fields, this.values, e.strings);
    const i = this.fields.find((a) => this.errors[a.key]);
    if (i) {
      this.$nextTick(() => this.control(i.key)?.focus());
      return;
    }
    const n = Ri(this.fields, this.values, this.context());
    this.saving = !0, z(this).giftDraft = {
      open: !0,
      editing: !1,
      card: !1,
      values: {},
      error: ""
    };
    let r = 0;
    try {
      for (const a of n)
        await z(this).postCart(a.path, a.body, { swap: a.swap }), r++;
      z(this).announce(e.cardVariantId !== null && !e.cardInCart ? e.strings.cardAdded : e.strings.saved);
    } catch {
      this.saving = !1, this.error = e.strings.error, this.persist(), r > 0 && n.length > 1 && await z(this).refresh();
    }
  },
  async remove() {
    if (ce() || this.saving) return;
    this.error = "", this.saving = !0, this.clearDraft();
    const i = Di(this.fields, this.context());
    try {
      await z(this).postCart(i.path, i.body, { swap: i.swap }), z(this).announce(e.cardVariantId !== null && e.cardInCart ? e.strings.cardRemoved : e.strings.removed);
    } catch {
      this.saving = !1, this.error = e.strings.error, this.persist();
    }
  }
})), Mi = (t) => t.data("collectionFilters", (e) => ({
  ...e,
  open: !1,
  fadeTransition: {
    "x-transition:enter": "transition-opacity ease-linear duration-300",
    "x-transition:enter-start": "opacity-0",
    "x-transition:enter-end": "opacity-100",
    "x-transition:leave": "transition-opacity ease-linear duration-300",
    "x-transition:leave-start": "opacity-100",
    "x-transition:leave-end": "opacity-0"
  },
  slideTransition: {
    "x-transition:enter": "transition ease-in-out duration-300 transform",
    "x-transition:enter-start": "-translate-x-full",
    "x-transition:enter-end": "translate-x-0",
    "x-transition:leave": "transition ease-in-out duration-300 transform",
    "x-transition:leave-start": "translate-x-0",
    "x-transition:leave-end": "-translate-x-full"
  }
})), ji = (t) => t.data("collectionProductForm", (e) => ({
  storeKey: e.storeKey,
  products: [],
  selectedProductIdx: 0,
  selectedVariantId: null,
  loading: !1,
  get product() {
    return this.products[this.selectedProductIdx] || null;
  },
  get variantOptions() {
    return this.product ? this.product.variants.map((i) => ({
      id: i.id,
      label: i.title,
      price: i.price,
      compareAtPrice: i.compareAtPrice
    })) : [];
  },
  get productOptions() {
    return this.products.map((i, n) => ({
      idx: n,
      label: i.title,
      price: i.variants[0]?.price || ""
    })).sort((i, n) => parseInt(i.label) - parseInt(n.label));
  },
  get sellingPlanId() {
    return this.product?.sellingPlanGroups?.[0]?.sellingPlans?.[0]?.id ?? null;
  },
  get selectedVariant() {
    return !this.product || !this.selectedVariantId ? null : this.product.variants.find((i) => i.id === this.selectedVariantId) ?? null;
  },
  get canBuy() {
    return !!this.selectedVariantId;
  },
  onVariantChange() {
    this.syncStore();
  },
  syncStore() {
    const i = t.store(this.storeKey);
    i && (i.productId = this.product?.id ?? null, i.variantId = this.selectedVariantId, i.imageUrl = this.selectedVariant?.image || this.product?.featuredImage || "");
  },
  async addToCart() {
    if (!this.canBuy) return;
    this.loading = !0;
    const i = {
      id: this.selectedVariantId,
      quantity: 1
    };
    this.sellingPlanId && (i.selling_plan = this.sellingPlanId);
    try {
      (await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [i] })
      })).ok && this.$store.cart.open();
    } catch (n) {
      console.error("Add to cart failed:", n);
    } finally {
      this.loading = !1;
    }
  },
  init() {
    if (this.products = JSON.parse(document.getElementById(e.dataId).textContent), t.store(this.storeKey) || t.store(this.storeKey, {
      productId: null,
      variantId: null,
      imageUrl: null
    }), e.defaultProduct) {
      const i = this.products.findIndex((n) => n.title.toLowerCase().includes(e.defaultProduct.toLowerCase()));
      i !== -1 && (this.selectedProductIdx = i);
    }
    this.syncStore(), this.$watch("selectedProductIdx", (i, n) => {
      const r = this.products[n]?.variants.find((a) => a.id === this.selectedVariantId)?.title ?? null;
      if (this.selectedVariantId = null, r) {
        const a = this.products[i]?.variants.find((s) => s.title === r);
        a && (this.selectedVariantId = a.id);
      }
      this.syncStore();
    });
  }
})), qi = (t) => t.data("detailsElement", () => ({
  isOpen: !1,
  theDetails: null,
  summaryElement: null,
  init() {
    this.summaryElement = this.$el.querySelector("summary"), this.summaryElement.setAttribute("aria-expanded", !1), this.summaryElement.setAttribute("aria-controls", this.$refs.contentElement.id), this.theDetails = this.$el, this.$watch("$store.mobileMenu.visible", (e) => !e && this.close());
  },
  open() {
    this.summaryElement.setAttribute("aria-expanded", !0), this.$nextTick(() => {
      this.isOpen = !0;
    });
  },
  cleanUp() {
    setTimeout(() => {
      this.theDetails.removeAttribute("open").then(() => this.isOpen = !1);
    }, 200);
  },
  close() {
    this.isOpen = !1, this.summaryElement.setAttribute("aria-expanded", !1), setTimeout(() => {
      this.theDetails.removeAttribute("open");
    }, 300);
  },
  detailsContent: {
    "x-show"() {
      return this.isOpen;
    },
    "x-transition:enter": "transition-transform",
    "x-transition:enter-start": "translate-x-full",
    "x-transition:leave": "transition-transform",
    "x-transition:leave-end": "translate-x-full"
  }
})), Bi = (t) => {
  t.addRootSelector(() => `[${t.prefixed("dynamic-image")}]`), t.addInitSelector(() => `[${t.prefixed("dynamic-image-broadcaster")}]`), t.directive("dynamic-image", Be), t.directive("dynamic-image-broadcaster", Vi), t.directive("dynamic-image-image", Ki);
}, qe = /* @__PURE__ */ new WeakMap(), Be = (t, e, { Alpine: i }) => {
  console.log("Setting up Dynamic Image Node");
  const n = qe.get(t);
  if (!n) return console.error("Dynamic Image Failed to Register: ", t, e.value);
  i.addScopeToNode(t, n);
};
Be.inline = (t, e, { Alpine: i, cleanup: n }) => {
  console.log("Setting Dynamic Image Handler");
  const r = i.reactive({ image: null });
  qe.set(t, r);
  const a = new AbortController();
  t.closest("section")?.addEventListener("dynamic-image-update", (s) => {
    console.log("Dynamic Image receiving Event"), r.image = s.detail;
  }, { signal: a.signal }), n(a.abort.bind(a));
};
var Vi = (t, { value: e, expression: i, modifiers: n }, { Alpine: r, cleanup: a }) => {
  if (console.log("Setting up Dynamic Image Broadcaster"), e === "intersect") {
    console.log("Dynamic Image Root:", i);
    const s = new IntersectionObserver((o) => {
      for (const l of o) l.isIntersecting ? (console.log("Dynamic Image Broadcaster Intersecting "), Hi(t)) : console.log("Dynamic Image Broadcaster NOT Intersecting ");
    }, { rootMargin: i });
    n.includes("parent") && s.observe(t.parentElement), s.observe(t), a(s.disconnect.bind(s));
  }
}, Hi = (t) => {
  t.dispatchEvent(new CustomEvent("dynamic-image-update", {
    detail: JSON.parse(t.querySelector("script")?.textContent ?? "null"),
    bubbles: !0
  }));
}, Ki = (t, e, { Alpine: i, effect: n }) => {
  if (!(t instanceof HTMLTemplateElement)) return console.error("Dynamic Image Image must be Template Element");
  const r = t.content;
  let a = null;
  const s = i.$data(t);
  console.log("Registering Dynamic Image Effect"), n(() => {
    if (console.log("running Dynamic Image Effect"), "image" in s && s.image) {
      const o = s.image, l = document.importNode(r, !0).firstElementChild;
      if (!(l instanceof HTMLImageElement)) return console.error("Dynamic Image Template Must have an img child");
      if (i.bind(l, {
        "x-rias"() {
          return o.url;
        },
        width: o.width,
        height: o.height,
        alt: o.alt
      }), (a ?? t).after(l), new Animation(new KeyframeEffect(l, [{ opacity: "0" }, { opacity: "1" }], {
        duration: 500,
        fill: "both"
      })).play(), a) {
        const c = new Animation(new KeyframeEffect(a, [{ opacity: "1" }, { opacity: "0" }], {
          duration: 500,
          fill: "both",
          delay: 500
        }));
        c.play(), c.addEventListener("finish", a.remove.bind(a));
      }
      a = l;
    }
  });
}, zi = (t) => t == null ? [] : Array.isArray(t) ? t.map((e) => Number(e)) : typeof t == "number" && !Number.isNaN(t) ? [t] : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean).map((e) => Number(e)) : [], Wi = (t) => t ? Array.isArray(t) ? t.map(String) : typeof t == "string" ? t.split(",").map((e) => e.trim()).filter(Boolean) : [] : [], Ui = (t) => t ? typeof t == "string" ? t : String(t) : "", Tt = (t) => {
  const e = t ?? {};
  let i = Number(e.cutOffHour);
  Number.isFinite(i) || (i = 14);
  let n = Number(e.leadTime);
  return Number.isFinite(n) || (n = 0), {
    cutOffHour: i,
    leadTime: n,
    messageHtml: Ui(e.messageHtml),
    isCustomMessage: !!e.isCustomMessage,
    restrictedDays: zi(e.restrictedDays),
    restrictedDates: Wi(e.restrictedDates)
  };
}, ue = (t) => t.dayOfWeek % 7, Gi = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
], Yi = (t) => {
  let e = Math.max(0, Math.floor(t));
  const i = Math.floor(e / 86400);
  e %= 86400;
  const n = Math.floor(e / 3600);
  return e %= 3600, {
    days: i,
    hours: n,
    minutes: Math.floor(e / 60),
    seconds: e % 60
  };
}, Ji = (t) => {
  const e = t.dataset.esCfgId;
  if (!e) return Tt(void 0);
  const i = document.getElementById(e);
  if (!i?.textContent?.trim()) return Tt(void 0);
  try {
    const n = JSON.parse(i.textContent);
    return Tt(n);
  } catch {
    return Tt(void 0);
  }
}, Gt = "America/Chicago", Xi = (t) => {
  t.data("estimatedShipping", (e = {}) => ({
    cutOffHour: 0,
    leadTime: 0,
    messageHtml: "",
    isCustomMessage: !1,
    restrictedDays: [],
    restrictedDates: [],
    message: "",
    intervalId: null,
    async init() {
      "Temporal" in globalThis || await import("./global.esm-ShPgAYTn.js"), Object.assign(this, Ji(this.$el), e), this.tick(), this.intervalId = setInterval(() => this.tick(), 1e3);
    },
    destroy() {
      clearInterval(this.intervalId);
    },
    tick() {
      const i = Temporal.Now.zonedDateTimeISO(Gt), n = this.nextCutoffDate(), r = n.epochNanoseconds - i.epochNanoseconds, a = r <= 0n ? 0 : Number(r / 1000000000n), { days: s, hours: o, minutes: l, seconds: c } = Yi(a), d = [];
      (d.length || s) && d.push(s === 1 ? `${s} day` : `${s} days`), (d.length || o) && d.push(o === 1 ? `${o} hour` : `${o} hours`), (d.length || l) && d.push(l === 1 ? `${l} minute` : `${l} minutes`), (d.length || c) && d.push(c === 1 ? `${c} second` : `${c} seconds`);
      const u = this.nextShippingDate(n), p = u.toPlainDate().equals(Temporal.Now.plainDateISO()) ? "Today" : Gi[ue(u)];
      this.message = String(this.messageHtml).replace("%countdown%", d.join(", ")).replace("%ship_day%", p);
    },
    nextCutoffDate() {
      const i = Temporal.Now.zonedDateTimeISO(Gt);
      let n = Temporal.Now.zonedDateTimeISO(Gt).with({
        hour: this.cutOffHour,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      for (Temporal.ZonedDateTime.compare(n, i) === -1 && (n = n.add({ days: 1 })); this.isDateRestricted(n); ) n = n.add({ days: 1 });
      return n;
    },
    nextShippingDate(i) {
      let n = i, r = this.leadTime;
      for (; this.isDateRestricted(n) || r > 0; )
        n = n.add({ days: 1 }), this.isDateRestricted(n) || r--;
      return n;
    },
    isDateRestricted(i) {
      if (this.restrictedDays.includes(ue(i))) return !0;
      const n = i.toPlainDate().toString(), r = n.slice(5);
      return this.restrictedDates.some((a) => a === n || a === r);
    }
  }));
}, Qi = (t) => {
  t.data("filterController", (n) => {
    const r = [];
    return n || console.error("No grid selector provided to filterController"), {
      forms: {},
      async init() {
        await t.nextTick(), this.facetChange(!1), r.push(t.effect(() => this.filterProducts())), window.addEventListener("popstate", this.updateFromHistory.bind(this));
      },
      updateFromHistory({ state: a }) {
        this.facetData = a ? JSON.parse(a) : this.facetChange();
        const s = this.facetData;
        document.querySelectorAll("#filter-drawer input[type=checkbox]").forEach((c) => {
          c.checked = s.some(([d, u]) => d === c.name && u === c.value);
        });
        const o = s.find(([c]) => c === "sort_by")?.[1];
        if (!o) return;
        const l = document.querySelector('select[name="sort_by"]');
        l && (l.value = o);
      },
      destroy() {
        r.forEach(t.release);
      },
      _expanded: [!0],
      expanded(a) {
        return this._expanded[a];
      },
      expand(a) {
        this._expanded[a] = !this._expanded[a];
      },
      open: !1,
      fadeTransition: wi,
      slideTransition: je,
      facetData: [],
      facetChange(a = !0) {
        return this.facetData = Object.values(this.forms).flatMap((s) => Array.from(new FormData(s).entries())).filter(([s, o]) => !(s === "sort_by" && o === "manual" || s === "page" && (a || o === "1"))), this.facetData;
      },
      filterProducts() {
        i(this.facetData, n);
      },
      get isFiltered() {
        return this.facetData.some(([a]) => ![
          "type",
          "sort_by",
          "q"
        ].includes(a));
      }
    };
  });
  let e = !0;
  const i = mi(async (n, r) => {
    const a = new URL(window.location.href);
    a.search = new URLSearchParams(n).toString();
    const s = await Ii(a);
    if (!s) return;
    e || Jt(s, r);
    const o = a.toString() === window.location.href;
    history[e || o ? "replaceState" : "pushState"](JSON.stringify(n), "", a.toString()), e = !1;
  });
}, Zi = (t) => {
  t.data("meganav", () => ({
    isVisible: !1,
    meganavIndex: 0,
    init() {
      this.meganavIndex = this.$store.meganavState.registerItem();
    },
    show() {
      this.isVisible = !0, this.$store.meganavState.items[this.meganavIndex] = !0;
    },
    hide() {
      this.isVisible = !1, this.$store.meganavState.items[this.meganavIndex] = !1;
    },
    toggle() {
      this.isVisible = !this.isVisible, t.nextTick(() => this.$store.meganavStateIsOpen = this.isVisible);
    },
    expand: {
      "@mouseover"() {
        this.show();
      },
      "@mouseleave"() {
        this.hide();
      },
      "@keydown.tab"() {
        this.$event.target.isSameNode(this.$focus.getLast()) && this.isVisible && !this.$event.shiftKey && (this.isVisible = !1);
      },
      "@keydown.shift.tab"() {
        this.$event.target.isSameNode(this.$focus.getFirst()) && this.isVisible && (this.isVisible = !1);
      },
      "@keydown.esc"() {
        this.$focus.getFirst().focus(), this.isVisible = !1;
      },
      "@keydown.down.prevent"() {
        this.$focus.wrap().next();
      },
      "@keydown.up.prevent"() {
        this.$focus.wrap().previous();
      }
    },
    fade: {
      "x-transition:enter": "transition-[top] duration-200",
      "x-transition:enter-start": "top-5",
      "x-transition:enter-end": "top-3",
      "x-transition:leave": "transition-[top] duration-200",
      "x-transition:leave-start": "top-3",
      "x-transition:leave-end": "top-5"
    }
  })), t.store("meganavState", {
    get isOpen() {
      return this.items.length ? this.items.some((e) => e) : !1;
    },
    items: [],
    registerItem() {
      return this.items.push(!1), this.items.length - 1;
    }
  });
}, tn = (t) => t.data("mobileMenu", () => ({
  size: "auto",
  adjustSize() {
    const e = this.$refs.menuDrawer;
    if (!e) return;
    const i = e.closest("section > :is(div.relative, div.absolute)");
    if (!i) return;
    const n = i.getBoundingClientRect(), r = n.y + n.height;
    this.size = `${r}px`;
  },
  adjustToLargestPart(e) {
    const i = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT);
    let n = 0, r = e;
    do
      n = Math.max(n, r.scrollHeight);
    while (r = i.nextNode());
    this.size = `${n + 5}px`;
  },
  get isOpen() {
    return this.$nextTick(() => this.$dispatch("update-size")), this.$store.mobileMenu.visible;
  },
  open() {
    this.$store.mobileMenu.show();
  },
  close() {
    this.$store.mobileMenu.hide();
  },
  cleanUp() {
    this.$refs.menuDrawerList.querySelectorAll("details").forEach((e) => e.removeAttribute("open"));
  }
})), en = (t) => t.data("modal", () => ({
  isOpen: !1,
  init() {
    this.$watch("$store.modal.isOpen", (e) => {
      !e && this.close(!1);
    });
  },
  open() {
    this.$dispatch("nt:modal-open"), this.isOpen = !0, this.$store.modal.open();
  },
  close(e = !0) {
    this.$dispatch("nt:modal-close"), this.isOpen = !1, e && this.$store.modal.close();
  }
})), nn = (t) => {
  t.addRootSelector(() => `[${t.prefixed("panel-stack")}]`), t.directive("panel-stack", an);
}, rn = /* @__PURE__ */ new Set([
  "STYLE",
  "SCRIPT",
  "TEMPLATE",
  "LINK"
]), an = (t, { expression: e }, { Alpine: i, effect: n, cleanup: r }) => {
  const a = i.reactive({ index: 0 }), s = new AbortController();
  r(s.abort.bind(s)), n(() => {
    const o = a.index;
    sn(t).forEach((l, c) => {
      l.classList.toggle("panel-current", c === o), l.classList.toggle("panel-previous", c < o), l.classList.toggle("panel-next", c > o), l.setAttribute("aria-hidden", String(c !== o));
    });
  }), queueMicrotask(() => {
    if (s.signal.aborted) return;
    const o = ln(t, e, on(i));
    o && (un(o, t, a, s.signal, n), cn(o, t, a, i, n)), queueMicrotask(() => t.classList.add("panels-ready"));
  });
}, sn = (t) => Array.from(t.children).filter((e) => e instanceof HTMLElement && !rn.has(e.tagName)), Ve = (t) => {
  const e = t.prefixed("accordion");
  return `[${e}], [${e}\\.open], [${e}\\.closed]`;
}, on = (t) => `[data-panel-trigger], ${Ve(t)}`, ee = (t, e, i) => Array.from(t.querySelectorAll(i)).filter((n) => !e.contains(n)), ln = (t, e, i) => {
  if (e) return t.closest(e) ?? document.querySelector(e);
  let n = t.parentElement;
  for (; n; ) {
    if (ee(n, t, i).length) return n;
    if (n.tagName === "SECTION") return null;
    n = n.parentElement;
  }
  return null;
}, cn = (t, e, i, n, r) => {
  ee(t, e, Ve(n)).map((a) => n.evaluate(a, "$accordion")).forEach((a, s) => {
    a && r(() => {
      a.active && (i.index = s);
    });
  });
}, un = (t, e, i, n, r) => {
  const a = ee(t, e, "[data-panel-trigger]");
  if (!a.length) return;
  const s = a.map((o) => [o.dataset.panelTriggerTarget === "parent" ? o.parentElement ?? o : o, o.dataset.panelTrigger ?? "hover"]);
  s.forEach(([o, l], c) => {
    const d = () => {
      i.index = c;
    };
    l === "click" ? o.addEventListener("click", d, { signal: n }) : l === "hover" ? (o.addEventListener("pointerenter", d, { signal: n }), o.addEventListener("focusin", d, { signal: n })) : console.error("x-panel-trigger action: ", l, " is invalid. Use 'hover' or 'click'.");
  }), r(() => {
    const o = i.index;
    s.forEach(([l], c) => l.classList.toggle("trigger-current", c === o));
  });
}, dn = (t) => {
  t.data("productCard", (e) => ({
    variant: e,
    get image() {
      return this.variant.featuredImage;
    },
    get currentShade() {
      const { name: i, description: n, color: r } = this.variant;
      return {
        name: i,
        description: n,
        color: r
      };
    },
    get colorDisplay() {
      const { name: i } = this.variant;
      return `${i}`;
    },
    get queryString() {
      return `?variant=${this.variant.id}`;
    },
    setShade(i) {
      Object.assign(this, { variant: i });
    },
    get isOnSale() {
      return this.variant.price < (this.variant.compare_at_price ?? 0);
    }
  }));
}, He = class extends Error {
}, Yt = /* @__PURE__ */ new Map(), fn = (t) => typeof t == "string" ? t : t.name, hn = (t, e) => {
  const i = Yt.get(t);
  if (i) return i;
  const n = window.Shopify?.routes?.root ?? "/", r = fetch(`${n}products/${t}?view=quickadd`).then((a) => {
    if (a.status === 404) throw new He(t);
    if (!a.ok) throw new Error(`Quick add: ${a.status}`);
    return a.json();
  }).then((a) => ({
    optionNames: a.options.map(fn),
    variants: a.variants.map((s) => ({
      id: s.id,
      options: s.options,
      available: s.available,
      price: e(s.price / 100),
      label: s.label
    }))
  }));
  return r.catch(() => Yt.delete(t)), Yt.set(t, r), r;
}, pn = 500, vn = 5e3, mn = (t) => {
  t.data("quickAdd", (e) => ({
    text: e.text,
    title: e.title,
    label: e.label,
    soldOut: e.available === !1,
    handle: e.handle ?? null,
    variants: e.variants ?? [],
    optionNames: e.optionNames ?? [],
    open: !1,
    hasPanel: (e.variants ?? []).length > 1,
    step: 0,
    picked: [],
    busy: !1,
    pendingFocus: 0,
    loading: !1,
    status: "",
    error: "",
    requestId: 0,
    loadingTimer: 0,
    statusTimer: 0,
    get panelId() {
      return `quick-add-panel-${e.blockId}-${e.uid}`;
    },
    get scopeId() {
      return `shopify-block-${e.blockId}-${e.uid}`;
    },
    get loaded() {
      return this.variants.length > 0;
    },
    get isLast() {
      return this.step === this.optionNames.length - 1;
    },
    get optionName() {
      return this.optionNames[this.step] ?? "";
    },
    get panelLabel() {
      return this.optionName ? `${this.text.choose} — ${this.optionName}` : null;
    },
    get choices() {
      const i = this.variants.filter((r) => this.picked.every((a, s) => r.options[s] === a)), n = /* @__PURE__ */ new Map();
      return i.forEach((r) => {
        const a = r.options[this.step], s = n.get(a);
        if (s) {
          r.available && !s.available && Object.assign(s, {
            available: !0,
            id: r.id,
            price: r.price,
            label: this.labelFor(r, a)
          });
          return;
        }
        n.set(a, {
          value: a,
          options: r.options,
          available: r.available,
          id: r.id,
          price: r.price,
          label: this.labelFor(r, a)
        });
      }), this.withoutCollidingLabels(Array.from(n.values()));
    },
    labelFor(i, n) {
      return this.isLast && i.label || n;
    },
    withoutCollidingLabels(i) {
      const n = /* @__PURE__ */ new Map();
      return i.forEach((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        n.set(a, (n.get(a) ?? 0) + 1);
      }), i.map((r) => {
        const a = r.label.trim().toLowerCase().replace(/\s+/g, " ");
        return (n.get(a) ?? 0) < 2 ? r : {
          ...r,
          label: r.value
        };
      });
    },
    detail(i) {
      return i.available ? this.isLast ? i.price : "" : this.text.soldOut;
    },
    get alive() {
      return !!this.$root?.isConnected;
    },
    say(i) {
      window.clearTimeout(this.statusTimer), this.status = "", this.$nextTick(() => {
        this.alive && (this.status = i, i && (this.statusTimer = window.setTimeout(() => {
          this.status = "";
        }, vn)));
      });
    },
    focusMountedOption() {
      this.$nextTick(() => {
        this.alive && this.$refs.options?.querySelector("[data-quick-add-option]")?.focus();
      });
    },
    requestOptionFocus() {
      this.pendingFocus = this.requestId;
    },
    claimFocus(i) {
      this.pendingFocus && this.pendingFocus === this.requestId && this.open && this.$root?.contains(i) && (this.pendingFocus = 0, i.focus());
    },
    focusFirstOption() {
      if (this.$refs.options?.querySelector("[data-quick-add-option]")) {
        this.focusMountedOption();
        return;
      }
      this.requestOptionFocus();
    },
    reset() {
      this.step = 0, this.picked = [];
    },
    close(i) {
      this.open = !1, this.$refs.panel?.close(), this.pendingFocus = 0, this.reset(), i && this.alive && this.$refs.trigger?.focus();
    },
    back() {
      if (this.step === 0) {
        this.close(!0);
        return;
      }
      this.step = this.step - 1, this.picked = this.picked.slice(0, this.step), this.requestOptionFocus();
    },
    select(i) {
      if (i.available && this.loaded) {
        if (this.isLast) {
          this.add(i);
          return;
        }
        this.picked = this.picked.slice(0, this.step).concat(i.value), this.step = this.step + 1, this.requestOptionFocus();
      }
    },
    onEscape(i) {
      if (!this.open && !this.loading) return;
      i.stopPropagation();
      const n = this.open;
      this.requestId += 1, window.clearTimeout(this.loadingTimer), this.loading = !1, this.close(n || document.activeElement === document.body);
    },
    async ensureLoaded(i) {
      if (this.loaded) return !0;
      if (!this.handle) return !1;
      this.loading = !0, this.loadingTimer = window.setTimeout(() => {
        this.loading && this.requestId === i && this.say(this.text.loading);
      }, pn);
      try {
        const n = await hn(this.handle, this.$formatMoney);
        return this.requestId !== i || !this.alive ? !1 : (this.optionNames = n.optionNames, this.variants = n.variants, !0);
      } catch (n) {
        return this.requestId !== i || !this.alive || (n instanceof He ? this.say(this.text.unavailable.replace("[product]", () => this.title)) : this.error = this.text.loadFailed.replace("[product]", () => this.title)), !1;
      } finally {
        window.clearTimeout(this.loadingTimer), this.loading = !1;
      }
    },
    async activate() {
      if (this.busy || this.soldOut) return;
      if (this.open) {
        this.close(!1);
        return;
      }
      this.busy = !0, this.error = "";
      const i = this.requestId += 1;
      try {
        if (!await this.ensureLoaded(i)) return;
        if (!this.variants.some((n) => n.available)) {
          this.soldOut = !0, this.say(this.text.soldOutProduct.replace("[product]", () => this.title));
          return;
        }
        if (this.variants.length === 1) {
          await this.addVariant(this.variants[0].id, this.title);
          return;
        }
        if (this.reset(), this.hasPanel = !0, await this.$nextTick(), this.requestId !== i || !this.alive) return;
        this.open = !0, this.$refs.panel?.show(), document.activeElement === this.$refs.trigger ? this.focusFirstOption() : this.say(`${this.title}. ${this.panelLabel ?? ""}`);
      } finally {
        this.busy = !1;
      }
    },
    get cart() {
      return this.$store.cart;
    },
    get itemCount() {
      return this.cart.data.item_count ?? 0;
    },
    async syncCart() {
      this.cart.data.items || (this.cart.data = await this.cart.getState());
    },
    async add(i) {
      if (!this.busy) {
        this.busy = !0;
        try {
          await this.addVariant(i.id, i.value);
        } finally {
          this.busy = !1;
        }
      }
    },
    async addVariant(i, n) {
      this.error = "", this.say(this.text.adding), await this.syncCart();
      const r = this.itemCount;
      if (await this.cart.addItem(i), !!this.alive) {
        if (this.itemCount === r) {
          this.error = this.text.failed;
          return;
        }
        this.say(this.text.added.replace("[variant]", () => n)), this.close(!0), this.cart.open();
      }
    },
    destroy() {
      window.clearTimeout(this.loadingTimer), window.clearTimeout(this.statusTimer);
    }
  }));
}, gn = (t) => {
  t.data("quickOrder", (e) => ({
    removing: !1,
    get cart() {
      return this.$store.cart;
    },
    get productEntries() {
      return this.cart.items.filter((i) => i.product_id === e);
    },
    get quantity() {
      return this.productEntries.reduce((i, n) => i + n.quantity, 0);
    },
    get subtotal() {
      return this.$formatMoney(this.productEntries.reduce((i, n) => i + n.final_line_price, 0) / 100);
    },
    async removeAll() {
      this.removing = !0;
      for (const { id: i } of this.productEntries)
        await this.cart.removeItem(i), this.$dispatch("removeall", { id: i });
      this.removing = !1;
    }
  })), t.data("quickOrderRow", (e, i) => ({
    quantity: t.store("cart").items.find((n) => n.id === Number(e))?.quantity ?? 0,
    price: i,
    get priceDisplay() {
      return this.$formatMoney(this.price * this.quantity / 100);
    }
  })), t.data("quickQuantity", (e) => ({
    q: 0,
    get quant() {
      return this.q;
    },
    set quant(i) {
      i = Math.max(0, i), this.q = i;
    }
  }));
}, bn = (t) => t.data("sizes", (e) => ({
  ...e,
  changeSize(i) {
    this.$dispatch("product-change", { product: i.product }), history.replaceState(null, i.product.title, i.url);
  }
})), yn = (t) => {
  t.data("stickyATC", () => ({
    show: !1,
    PDPATC: document.querySelector("#atc-button button[name=add]"),
    onScroll() {
      if (!this.PDPATC) return;
      const e = this.PDPATC.getBoundingClientRect();
      this.show = e.top < 25;
    }
  }));
}, wn = (t) => {
  t.addRootSelector(() => `[${t.prefixed("stickyheader")}]`), t.directive("stickyheader", (e, i, { cleanup: n }) => {
    console.log("checking sticky header");
    const r = e.closest("section");
    if (!r || !("Animation" in globalThis)) return;
    console.log("setting up sticky header animation");
    const a = new Animation(new KeyframeEffect(r, [{ top: "0px" }, { get top() {
      return `-${e.clientHeight}px`;
    } }], {
      duration: 500,
      fill: "both"
    }));
    a.persist(), a.reverse(), a.finish();
    const s = t.effect(() => {
      const o = +(t.$scroll.direction === "down" && !t.$scroll.nearTop && !t.store("search").isOpen);
      a.playbackRate = o * 2 - 1;
    });
    n(() => t.release(s));
  });
}, xn = [
  xi,
  Ei,
  Ti,
  Bi,
  Xi,
  Si,
  Li,
  Pi,
  Mi,
  ji,
  qi,
  Qi,
  Zi,
  tn,
  en,
  nn,
  dn,
  mn,
  gn,
  bn,
  yn,
  wn
], _t = Math.min, nt = Math.max, At = Math.round, kt = Math.floor, Q = (t) => ({
  x: t,
  y: t
}), En = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Sn = {
  start: "end",
  end: "start"
};
function de(t, e, i) {
  return nt(t, _t(e, i));
}
function qt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function rt(t) {
  return t.split("-")[0];
}
function Bt(t) {
  return t.split("-")[1];
}
function Ke(t) {
  return t === "x" ? "y" : "x";
}
function ze(t) {
  return t === "y" ? "height" : "width";
}
function Vt(t) {
  return ["top", "bottom"].includes(rt(t)) ? "y" : "x";
}
function We(t) {
  return Ke(Vt(t));
}
function Tn(t, e, i) {
  i === void 0 && (i = !1);
  const n = Bt(t), r = We(t), a = ze(r);
  let s = r === "x" ? n === (i ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[a] > e.floating[a] && (s = Ft(s)), [s, Ft(s)];
}
function kn(t) {
  const e = Ft(t);
  return [
    Xt(t),
    e,
    Xt(e)
  ];
}
function Xt(t) {
  return t.replace(/start|end/g, (e) => Sn[e]);
}
function In(t, e, i) {
  const n = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return i ? e ? r : n : e ? n : r;
    case "left":
    case "right":
      return e ? a : s;
    default:
      return [];
  }
}
function Cn(t, e, i, n) {
  const r = Bt(t);
  let a = In(rt(t), i === "start", n);
  return r && (a = a.map((s) => s + "-" + r), e && (a = a.concat(a.map(Xt)))), a;
}
function Ft(t) {
  return t.replace(/left|right|bottom|top/g, (e) => En[e]);
}
function Nn(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function On(t) {
  return typeof t != "number" ? Nn(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function $t(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function fe(t, e, i) {
  let { reference: n, floating: r } = t;
  const a = Vt(e), s = We(e), o = ze(s), l = rt(e), c = a === "y", d = n.x + n.width / 2 - r.width / 2, u = n.y + n.height / 2 - r.height / 2, p = n[o] / 2 - r[o] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: d,
        y: n.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      v = {
        x: n.x - r.width,
        y: u
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (Bt(e)) {
    case "start":
      v[s] -= p * (i && c ? -1 : 1);
      break;
    case "end":
      v[s] += p * (i && c ? -1 : 1);
  }
  return v;
}
var Ln = async (t, e, i) => {
  const { placement: n = "bottom", strategy: r = "absolute", middleware: a = [], platform: s } = i, o = a.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), { x: d, y: u } = fe(c, n, l), p = n, v = {}, g = 0;
  for (let y = 0; y < o.length; y++) {
    const { name: m, fn: w } = o[y], { x: I, y: O, data: A, reset: _ } = await w({
      x: d,
      y: u,
      initialPlacement: n,
      placement: p,
      strategy: r,
      middlewareData: v,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (d = I ?? d, u = O ?? u, v = {
      ...v,
      [m]: {
        ...v[m],
        ...A
      }
    }, _ && g <= 50) {
      g++, typeof _ == "object" && (_.placement && (p = _.placement), _.rects && (c = _.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: r
      }) : _.rects), { x: d, y: u } = fe(c, p, l)), y = -1;
      continue;
    }
  }
  return {
    x: d,
    y: u,
    placement: p,
    strategy: r,
    middlewareData: v
  };
};
async function Ue(t, e) {
  var i;
  e === void 0 && (e = {});
  const { x: n, y: r, platform: a, rects: s, elements: o, strategy: l } = t, { boundary: c = "clippingAncestors", rootBoundary: d = "viewport", elementContext: u = "floating", altBoundary: p = !1, padding: v = 0 } = qt(e, t), g = On(v), y = o[p ? u === "floating" ? "reference" : "floating" : u], m = $t(await a.getClippingRect({
    element: (i = await (a.isElement == null ? void 0 : a.isElement(y))) == null || i ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), w = u === "floating" ? {
    ...s.floating,
    x: n,
    y: r
  } : s.reference, I = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(o.floating)), O = await (a.isElement == null ? void 0 : a.isElement(I)) ? await (a.getScale == null ? void 0 : a.getScale(I)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = $t(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: w,
    offsetParent: I,
    strategy: l
  }) : w);
  return {
    top: (m.top - A.top + g.top) / O.y,
    bottom: (A.bottom - m.bottom + g.bottom) / O.y,
    left: (m.left - A.left + g.left) / O.x,
    right: (A.right - m.right + g.right) / O.x
  };
}
var _n = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var i, n;
      const { placement: r, middlewareData: a, rects: s, initialPlacement: o, platform: l, elements: c } = e, { mainAxis: d = !0, crossAxis: u = !0, fallbackPlacements: p, fallbackStrategy: v = "bestFit", fallbackAxisSideDirection: g = "none", flipAlignment: y = !0, ...m } = qt(t, e);
      if ((i = a.arrow) != null && i.alignmentOffset) return {};
      const w = rt(r), I = rt(o) === o, O = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), A = p || (I || !y ? [Ft(o)] : kn(o));
      !p && g !== "none" && A.push(...Cn(o, y, g, O));
      const _ = [o, ...A], R = await Ue(e, m), k = [];
      let F = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (d && k.push(R[w]), u) {
        const S = Tn(r, s, O);
        k.push(R[S[0]], R[S[1]]);
      }
      if (F = [...F, {
        placement: r,
        overflows: k
      }], !k.every((S) => S <= 0)) {
        var K, U;
        const S = (((K = a.flip) == null ? void 0 : K.index) || 0) + 1, f = _[S];
        if (f) return {
          data: {
            index: S,
            overflows: F
          },
          reset: { placement: f }
        };
        let h = (U = F.filter((b) => b.overflows[0] <= 0).sort((b, E) => b.overflows[1] - E.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!h) switch (v) {
          case "bestFit": {
            var P;
            const b = (P = F.map((E) => [E.placement, E.overflows.filter((x) => x > 0).reduce((x, N) => x + N, 0)]).sort((E, x) => E[1] - x[1])[0]) == null ? void 0 : P[0];
            b && (h = b);
            break;
          }
          case "initialPlacement":
            h = o;
        }
        if (r !== h) return { reset: { placement: h } };
      }
      return {};
    }
  };
};
async function An(t, e) {
  const { placement: i, platform: n, elements: r } = t, a = await (n.isRTL == null ? void 0 : n.isRTL(r.floating)), s = rt(i), o = Bt(i), l = Vt(i) === "y", c = ["left", "top"].includes(s) ? -1 : 1, d = a && l ? -1 : 1, u = qt(e, t);
  let { mainAxis: p, crossAxis: v, alignmentAxis: g } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return o && typeof g == "number" && (v = o === "end" ? g * -1 : g), l ? {
    x: v * d,
    y: p * c
  } : {
    x: p * c,
    y: v * d
  };
}
var Fn = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const { x: i, y: n } = e, r = await An(e, t);
      return {
        x: i + r.x,
        y: n + r.y,
        data: r
      };
    }
  };
}, $n = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const { x: i, y: n, placement: r } = e, { mainAxis: a = !0, crossAxis: s = !1, limiter: o = { fn: (m) => {
        let { x: w, y: I } = m;
        return {
          x: w,
          y: I
        };
      } }, ...l } = qt(t, e), c = {
        x: i,
        y: n
      }, d = await Ue(e, l), u = Vt(rt(r)), p = Ke(u);
      let v = c[p], g = c[u];
      if (a) {
        const m = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", I = v + d[m], O = v - d[w];
        v = de(I, v, O);
      }
      if (s) {
        const m = u === "y" ? "top" : "left", w = u === "y" ? "bottom" : "right", I = g + d[m], O = g - d[w];
        g = de(I, g, O);
      }
      const y = o.fn({
        ...e,
        [p]: v,
        [u]: g
      });
      return {
        ...y,
        data: {
          x: y.x - i,
          y: y.y - n
        }
      };
    }
  };
};
function Z(t) {
  return Ge(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function V(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function J(t) {
  var e;
  return (e = (Ge(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Ge(t) {
  return t instanceof Node || t instanceof V(t).Node;
}
function Y(t) {
  return t instanceof Element || t instanceof V(t).Element;
}
function W(t) {
  return t instanceof HTMLElement || t instanceof V(t).HTMLElement;
}
function he(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof V(t).ShadowRoot;
}
function Et(t) {
  const { overflow: e, overflowX: i, overflowY: n, display: r } = H(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + i) && !["inline", "contents"].includes(r);
}
function Rn(t) {
  return [
    "table",
    "td",
    "th"
  ].includes(Z(t));
}
function ie(t) {
  const e = ne(), i = H(t);
  return i.transform !== "none" || i.perspective !== "none" || (i.containerType ? i.containerType !== "normal" : !1) || !e && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !e && (i.filter ? i.filter !== "none" : !1) || [
    "transform",
    "perspective",
    "filter"
  ].some((n) => (i.willChange || "").includes(n)) || [
    "paint",
    "layout",
    "strict",
    "content"
  ].some((n) => (i.contain || "").includes(n));
}
function Dn(t) {
  let e = dt(t);
  for (; W(e) && !Ht(e); ) {
    if (ie(e)) return e;
    e = dt(e);
  }
  return null;
}
function ne() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ht(t) {
  return [
    "html",
    "body",
    "#document"
  ].includes(Z(t));
}
function H(t) {
  return V(t).getComputedStyle(t);
}
function Kt(t) {
  return Y(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function dt(t) {
  if (Z(t) === "html") return t;
  const e = t.assignedSlot || t.parentNode || he(t) && t.host || J(t);
  return he(e) ? e.host : e;
}
function Ye(t) {
  const e = dt(t);
  return Ht(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : W(e) && Et(e) ? e : Ye(e);
}
function gt(t, e, i) {
  var n;
  e === void 0 && (e = []), i === void 0 && (i = !0);
  const r = Ye(t), a = r === ((n = t.ownerDocument) == null ? void 0 : n.body), s = V(r);
  return a ? e.concat(s, s.visualViewport || [], Et(r) ? r : [], s.frameElement && i ? gt(s.frameElement) : []) : e.concat(r, gt(r, [], i));
}
function Je(t) {
  const e = H(t);
  let i = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const r = W(t), a = r ? t.offsetWidth : i, s = r ? t.offsetHeight : n, o = At(i) !== a || At(n) !== s;
  return o && (i = a, n = s), {
    width: i,
    height: n,
    $: o
  };
}
function re(t) {
  return Y(t) ? t : t.contextElement;
}
function ut(t) {
  const e = re(t);
  if (!W(e)) return Q(1);
  const i = e.getBoundingClientRect(), { width: n, height: r, $: a } = Je(e);
  let s = (a ? At(i.width) : i.width) / n, o = (a ? At(i.height) : i.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: s,
    y: o
  };
}
var Pn = /* @__PURE__ */ Q(0);
function Xe(t) {
  const e = V(t);
  return !ne() || !e.visualViewport ? Pn : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Mn(t, e, i) {
  return e === void 0 && (e = !1), !i || e && i !== V(t) ? !1 : e;
}
function at(t, e, i, n) {
  e === void 0 && (e = !1), i === void 0 && (i = !1);
  const r = t.getBoundingClientRect(), a = re(t);
  let s = Q(1);
  e && (n ? Y(n) && (s = ut(n)) : s = ut(t));
  const o = Mn(a, i, n) ? Xe(a) : Q(0);
  let l = (r.left + o.x) / s.x, c = (r.top + o.y) / s.y, d = r.width / s.x, u = r.height / s.y;
  if (a) {
    const p = V(a), v = n && Y(n) ? V(n) : n;
    let g = p.frameElement;
    for (; g && n && v !== p; ) {
      const y = ut(g), m = g.getBoundingClientRect(), w = H(g), I = m.left + (g.clientLeft + parseFloat(w.paddingLeft)) * y.x, O = m.top + (g.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, d *= y.x, u *= y.y, l += I, c += O, g = V(g).frameElement;
    }
  }
  return $t({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function jn(t) {
  let { rect: e, offsetParent: i, strategy: n } = t;
  const r = W(i), a = J(i);
  if (i === a) return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = Q(1);
  const l = Q(0);
  if ((r || !r && n !== "fixed") && ((Z(i) !== "body" || Et(a)) && (s = Kt(i)), W(i))) {
    const c = at(i);
    o = ut(i), l.x = c.x + i.clientLeft, l.y = c.y + i.clientTop;
  }
  return {
    width: e.width * o.x,
    height: e.height * o.y,
    x: e.x * o.x - s.scrollLeft * o.x + l.x,
    y: e.y * o.y - s.scrollTop * o.y + l.y
  };
}
function qn(t) {
  return Array.from(t.getClientRects());
}
function Qe(t) {
  return at(J(t)).left + Kt(t).scrollLeft;
}
function Bn(t) {
  const e = J(t), i = Kt(t), n = t.ownerDocument.body, r = nt(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), a = nt(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -i.scrollLeft + Qe(t);
  const o = -i.scrollTop;
  return H(n).direction === "rtl" && (s += nt(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: a,
    x: s,
    y: o
  };
}
function Vn(t, e) {
  const i = V(t), n = J(t), r = i.visualViewport;
  let a = n.clientWidth, s = n.clientHeight, o = 0, l = 0;
  if (r) {
    a = r.width, s = r.height;
    const c = ne();
    (!c || c && e === "fixed") && (o = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: o,
    y: l
  };
}
function Hn(t, e) {
  const i = at(t, !0, e === "fixed"), n = i.top + t.clientTop, r = i.left + t.clientLeft, a = W(t) ? ut(t) : Q(1);
  return {
    width: t.clientWidth * a.x,
    height: t.clientHeight * a.y,
    x: r * a.x,
    y: n * a.y
  };
}
function pe(t, e, i) {
  let n;
  if (e === "viewport") n = Vn(t, i);
  else if (e === "document") n = Bn(J(t));
  else if (Y(e)) n = Hn(e, i);
  else {
    const r = Xe(t);
    n = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return $t(n);
}
function Ze(t, e) {
  const i = dt(t);
  return i === e || !Y(i) || Ht(i) ? !1 : H(i).position === "fixed" || Ze(i, e);
}
function Kn(t, e) {
  const i = e.get(t);
  if (i) return i;
  let n = gt(t, [], !1).filter((o) => Y(o) && Z(o) !== "body"), r = null;
  const a = H(t).position === "fixed";
  let s = a ? dt(t) : t;
  for (; Y(s) && !Ht(s); ) {
    const o = H(s), l = ie(s);
    !l && o.position === "fixed" && (r = null), (a ? !l && !r : !l && o.position === "static" && r && ["absolute", "fixed"].includes(r.position) || Et(s) && !l && Ze(t, s)) ? n = n.filter((c) => c !== s) : r = o, s = dt(s);
  }
  return e.set(t, n), n;
}
function zn(t) {
  let { element: e, boundary: i, rootBoundary: n, strategy: r } = t;
  const a = [...i === "clippingAncestors" ? Kn(e, this._c) : [].concat(i), n], s = a[0], o = a.reduce((l, c) => {
    const d = pe(e, c, r);
    return l.top = nt(d.top, l.top), l.right = _t(d.right, l.right), l.bottom = _t(d.bottom, l.bottom), l.left = nt(d.left, l.left), l;
  }, pe(e, s, r));
  return {
    width: o.right - o.left,
    height: o.bottom - o.top,
    x: o.left,
    y: o.top
  };
}
function Wn(t) {
  return Je(t);
}
function Un(t, e, i) {
  const n = W(e), r = J(e), a = i === "fixed", s = at(t, !0, a, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Q(0);
  if (n || !n && !a)
    if ((Z(e) !== "body" || Et(r)) && (o = Kt(e)), n) {
      const c = at(e, !0, a, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else r && (l.x = Qe(r));
  return {
    x: s.left + o.scrollLeft - l.x,
    y: s.top + o.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function ve(t, e) {
  return !W(t) || H(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function ti(t, e) {
  const i = V(t);
  if (!W(t)) return i;
  let n = ve(t, e);
  for (; n && Rn(n) && H(n).position === "static"; ) n = ve(n, e);
  return n && (Z(n) === "html" || Z(n) === "body" && H(n).position === "static" && !ie(n)) ? i : n || Dn(t) || i;
}
var Gn = async function(t) {
  let { reference: e, floating: i, strategy: n } = t;
  const r = this.getOffsetParent || ti, a = this.getDimensions;
  return {
    reference: Un(e, await r(i), n),
    floating: {
      x: 0,
      y: 0,
      ...await a(i)
    }
  };
};
function Yn(t) {
  return H(t).direction === "rtl";
}
var Jn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: jn,
  getDocumentElement: J,
  getClippingRect: zn,
  getOffsetParent: ti,
  getElementRects: Gn,
  getClientRects: qn,
  getDimensions: Wn,
  getScale: ut,
  isElement: Y,
  isRTL: Yn
};
function Xn(t, e) {
  let i = null, n;
  const r = J(t);
  function a() {
    clearTimeout(n), i && i.disconnect(), i = null;
  }
  function s(o, l) {
    o === void 0 && (o = !1), l === void 0 && (l = 1), a();
    const { left: c, top: d, width: u, height: p } = t.getBoundingClientRect();
    if (o || e(), !u || !p) return;
    const v = kt(d), g = kt(r.clientWidth - (c + u)), y = kt(r.clientHeight - (d + p)), m = kt(c), w = {
      rootMargin: -v + "px " + -g + "px " + -y + "px " + -m + "px",
      threshold: nt(0, _t(1, l)) || 1
    };
    let I = !0;
    function O(A) {
      const _ = A[0].intersectionRatio;
      if (_ !== l) {
        if (!I) return s();
        _ ? s(!1, _) : n = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      I = !1;
    }
    try {
      i = new IntersectionObserver(O, {
        ...w,
        root: r.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(O, w);
    }
    i.observe(t);
  }
  return s(!0), a;
}
function Qn(t, e, i, n) {
  n === void 0 && (n = {});
  const { ancestorScroll: r = !0, ancestorResize: a = !0, elementResize: s = typeof ResizeObserver == "function", layoutShift: o = typeof IntersectionObserver == "function", animationFrame: l = !1 } = n, c = re(t), d = r || a ? [...c ? gt(c) : [], ...gt(e)] : [];
  d.forEach((w) => {
    r && w.addEventListener("scroll", i, { passive: !0 }), a && w.addEventListener("resize", i);
  });
  const u = c && o ? Xn(c, i) : null;
  let p = -1, v = null;
  s && (v = new ResizeObserver((w) => {
    let [I] = w;
    I && I.target === c && v && (v.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      v && v.observe(e);
    })), i();
  }), c && !l && v.observe(c), v.observe(e));
  let g, y = l ? at(t) : null;
  l && m();
  function m() {
    const w = at(t);
    y && (w.x !== y.x || w.y !== y.y || w.width !== y.width || w.height !== y.height) && i(), y = w, g = requestAnimationFrame(m);
  }
  return i(), () => {
    d.forEach((w) => {
      r && w.removeEventListener("scroll", i), a && w.removeEventListener("resize", i);
    }), u && u(), v && v.disconnect(), v = null, l && cancelAnimationFrame(g);
  };
}
var Zn = (t, e, i) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: Jn,
    ...i
  }, a = {
    ...r.platform,
    _c: n
  };
  return Ln(t, e, {
    ...r,
    platform: a
  });
};
function tr(t) {
  t.magic("anchor", (e) => {
    if (!e._x_anchor) throw "Alpine: No x-anchor directive found on element using $anchor...";
    return e._x_anchor;
  }), t.interceptClone((e, i) => {
    e && e._x_anchor && !i._x_anchor && (i._x_anchor = e._x_anchor);
  }), t.directive("anchor", t.skipDuringClone((e, { expression: i, modifiers: n, value: r }, { evaluate: a, effect: s, cleanup: o }) => {
    let { placement: l, offsetValue: c, unstyled: d, strategy: u, allowFlip: p } = ge(n);
    e._x_anchor = t.reactive({
      x: 0,
      y: 0
    });
    let v = null, g = null;
    s(() => {
      let y = a(i);
      if (y && v !== y) {
        g && g(), v = y;
        let m = () => {
          let w;
          Zn(y, e, {
            placement: l,
            strategy: u,
            middleware: [
              p && _n(),
              $n({ padding: 5 }),
              Fn(c)
            ]
          }).then(({ x: I, y: O }) => {
            d || me(e, I, O, u), JSON.stringify({
              x: I,
              y: O
            }) !== w && (e._x_anchor.x = I, e._x_anchor.y = O), w = JSON.stringify({
              x: I,
              y: O
            });
          });
        };
        g = Qn(y, e, () => m());
      }
    }), o(() => {
      g && g();
    });
  }, (e, { expression: i, modifiers: n, value: r }, { cleanup: a, evaluate: s }) => {
    let { placement: o, offsetValue: l, unstyled: c, strategy: d } = ge(n);
    e._x_anchor && (c || me(e, e._x_anchor.x, e._x_anchor.y, d));
  }));
}
function me(t, e, i, n = "absolute") {
  Object.assign(t.style, {
    left: e + "px",
    top: i + "px",
    position: n
  });
}
function ge(t) {
  let e = [
    "top",
    "top-start",
    "top-end",
    "right",
    "right-start",
    "right-end",
    "bottom",
    "bottom-start",
    "bottom-end",
    "left",
    "left-start",
    "left-end"
  ].find((s) => t.includes(s)), i = 0;
  if (t.includes("offset")) {
    let s = t.findIndex((o) => o === "offset");
    i = t[s + 1] !== void 0 ? Number(t[s + 1]) : i;
  }
  let n = t.includes("no-style"), r = !t.includes("noflip"), a = t.includes("fixed") ? "fixed" : "absolute";
  return {
    placement: e,
    offsetValue: i,
    unstyled: n,
    strategy: a,
    allowFlip: r
  };
}
var er = tr;
function ir(t) {
  t.directive("collapse", e), e.inline = (i, { modifiers: n }) => {
    n.includes("min") && (i._x_doShow = () => {
    }, i._x_doHide = () => {
    });
  };
  function e(i, { modifiers: n }) {
    let r = be(n, "duration", 250) / 1e3, a = be(n, "min", 0), s = !n.includes("min");
    i._x_isShown || (i.style.height = `${a}px`), !i._x_isShown && s && (i.hidden = !0), i._x_isShown || (i.style.overflow = "hidden");
    let o = (c, d) => {
      let u = t.setStyles(c, d);
      return d.height ? () => {
      } : u;
    }, l = {
      transitionProperty: "height",
      transitionDuration: `${r}s`,
      transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
    };
    i._x_transition = {
      in(c = () => {
      }, d = () => {
      }) {
        s && (i.hidden = !1), s && (i.style.display = null);
        let u = i.getBoundingClientRect().height;
        i.style.height = "auto";
        let p = i.getBoundingClientRect().height;
        u === p && (u = a), t.transition(i, t.setStyles, {
          during: l,
          start: { height: u + "px" },
          end: { height: p + "px" }
        }, () => i._x_isShown = !0, () => {
          Math.abs(i.getBoundingClientRect().height - p) < 1 && (i.style.overflow = null);
        });
      },
      out(c = () => {
      }, d = () => {
      }) {
        let u = i.getBoundingClientRect().height;
        t.transition(i, o, {
          during: l,
          start: { height: u + "px" },
          end: { height: a + "px" }
        }, () => i.style.overflow = "hidden", () => {
          i._x_isShown = !1, i.style.height == `${a}px` && s && (i.style.display = "none", i.hidden = !0);
        });
      }
    };
  }
}
function be(t, e, i) {
  if (t.indexOf(e) === -1) return i;
  const n = t[t.indexOf(e) + 1];
  if (!n) return i;
  if (e === "duration") {
    let r = n.match(/([0-9]+)ms/);
    if (r) return r[1];
  }
  if (e === "min") {
    let r = n.match(/([0-9]+)px/);
    if (r) return r[1];
  }
  return n;
}
var nr = ir, ei = [
  "input:not([inert]):not([inert] *)",
  "select:not([inert]):not([inert] *)",
  "textarea:not([inert]):not([inert] *)",
  "a[href]:not([inert]):not([inert] *)",
  "button:not([inert]):not([inert] *)",
  "[tabindex]:not(slot):not([inert]):not([inert] *)",
  "audio[controls]:not([inert]):not([inert] *)",
  "video[controls]:not([inert]):not([inert] *)",
  '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
  "details>summary:first-of-type:not([inert]):not([inert] *)",
  "details:not([inert]):not([inert] *)"
], Rt = /* @__PURE__ */ ei.join(","), ii = typeof Element > "u", st = ii ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Dt = !ii && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, Pt = function(e, i) {
  var n;
  i === void 0 && (i = !0);
  var r = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "inert");
  return r === "" || r === "true" || i && e && (typeof e.closest == "function" ? e.closest("[inert]") : Pt(e.parentNode));
}, rr = function(e) {
  var i, n = e == null || (i = e.getAttribute) === null || i === void 0 ? void 0 : i.call(e, "contenteditable");
  return n === "" || n === "true";
}, ni = function(e, i, n) {
  if (Pt(e)) return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll(Rt));
  return i && st.call(e, Rt) && r.unshift(e), r = r.filter(n), r;
}, Mt = function(e, i, n) {
  for (var r = [], a = Array.from(e); a.length; ) {
    var s = a.shift();
    if (!Pt(s, !1))
      if (s.tagName === "SLOT") {
        var o = s.assignedElements(), l = Mt(o.length ? o : s.children, !0, n);
        n.flatten ? r.push.apply(r, l) : r.push({
          scopeParent: s,
          candidates: l
        });
      } else {
        st.call(s, Rt) && n.filter(s) && (i || !e.includes(s)) && r.push(s);
        var c = s.shadowRoot || typeof n.getShadowRoot == "function" && n.getShadowRoot(s), d = !Pt(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(s));
        if (c && d) {
          var u = Mt(c === !0 ? s.children : c.children, !0, n);
          n.flatten ? r.push.apply(r, u) : r.push({
            scopeParent: s,
            candidates: u
          });
        } else a.unshift.apply(a, s.children);
      }
  }
  return r;
}, ri = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, it = function(e) {
  if (!e) throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || rr(e)) && !ri(e) ? 0 : e.tabIndex;
}, ar = function(e, i) {
  var n = it(e);
  return n < 0 && i && !ri(e) ? 0 : n;
}, sr = function(e, i) {
  return e.tabIndex === i.tabIndex ? e.documentOrder - i.documentOrder : e.tabIndex - i.tabIndex;
}, ai = function(e) {
  return e.tagName === "INPUT";
}, or = function(e) {
  return ai(e) && e.type === "hidden";
}, lr = function(e) {
  return e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(i) {
    return i.tagName === "SUMMARY";
  });
}, cr = function(e, i) {
  for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === i) return e[n];
}, ur = function(e) {
  if (!e.name) return !0;
  var i = e.form || Dt(e), n = function(o) {
    return i.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function") r = n(window.CSS.escape(e.name));
  else try {
    r = n(e.name);
  } catch (s) {
    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", s.message), !1;
  }
  var a = cr(r, e.form);
  return !a || a === e;
}, dr = function(e) {
  return ai(e) && e.type === "radio";
}, fr = function(e) {
  return dr(e) && !ur(e);
}, hr = function(e) {
  var i, n = e && Dt(e), r = (i = n) === null || i === void 0 ? void 0 : i.host, a = !1;
  if (n && n !== e) {
    var s, o, l;
    for (a = !!((s = r) !== null && s !== void 0 && (o = s.ownerDocument) !== null && o !== void 0 && o.contains(r) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !a && r; ) {
      var c, d, u;
      n = Dt(r), r = (c = n) === null || c === void 0 ? void 0 : c.host, a = !!((d = r) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(r));
    }
  }
  return a;
}, ye = function(e) {
  var i = e.getBoundingClientRect(), n = i.width, r = i.height;
  return n === 0 && r === 0;
}, pr = function(e, i) {
  var n = i.displayCheck, r = i.getShadowRoot;
  if (n === "full-native" && "checkVisibility" in e)
    return !e.checkVisibility({
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      checkVisibilityCSS: !0
    });
  if (getComputedStyle(e).visibility === "hidden") return !0;
  var a = st.call(e, "details>summary:first-of-type") ? e.parentElement : e;
  if (st.call(a, "details:not([open]) *")) return !0;
  if (!n || n === "full" || n === "full-native" || n === "legacy-full") {
    if (typeof r == "function") {
      for (var s = e; e; ) {
        var o = e.parentElement, l = Dt(e);
        if (o && !o.shadowRoot && r(o) === !0) return ye(e);
        e.assignedSlot ? e = e.assignedSlot : !o && l !== e.ownerDocument ? e = l.host : e = o;
      }
      e = s;
    }
    if (hr(e)) return !e.getClientRects().length;
    if (n !== "legacy-full") return !0;
  } else if (n === "non-zero-area") return ye(e);
  return !1;
}, vr = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var i = e.parentElement; i; ) {
      if (i.tagName === "FIELDSET" && i.disabled) {
        for (var n = 0; n < i.children.length; n++) {
          var r = i.children.item(n);
          if (r.tagName === "LEGEND") return st.call(i, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      i = i.parentElement;
    }
  return !1;
}, jt = function(e, i) {
  return !(i.disabled || or(i) || pr(i, e) || lr(i) || vr(i));
}, Qt = function(e, i) {
  return !(fr(i) || it(i) < 0 || !jt(e, i));
}, mr = function(e) {
  var i = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(i) || i >= 0);
}, si = function(e) {
  var i = [], n = [];
  return e.forEach(function(r, a) {
    var s = !!r.scopeParent, o = s ? r.scopeParent : r, l = ar(o, s), c = s ? si(r.candidates) : o;
    l === 0 ? s ? i.push.apply(i, c) : i.push(o) : n.push({
      documentOrder: a,
      tabIndex: l,
      item: r,
      isScope: s,
      content: c
    });
  }), n.sort(sr).reduce(function(r, a) {
    return a.isScope ? r.push.apply(r, a.content) : r.push(a.content), r;
  }, []).concat(i);
}, gr = function(e, i) {
  i = i || {};
  var n;
  return i.getShadowRoot ? n = Mt([e], i.includeContainer, {
    filter: Qt.bind(null, i),
    flatten: !1,
    getShadowRoot: i.getShadowRoot,
    shadowRootFilter: mr
  }) : n = ni(e, i.includeContainer, Qt.bind(null, i)), si(n);
}, oi = function(e, i) {
  i = i || {};
  var n;
  return i.getShadowRoot ? n = Mt([e], i.includeContainer, {
    filter: jt.bind(null, i),
    flatten: !0,
    getShadowRoot: i.getShadowRoot
  }) : n = ni(e, i.includeContainer, jt.bind(null, i)), n;
}, lt = function(e, i) {
  if (i = i || {}, !e) throw new Error("No node provided");
  return st.call(e, Rt) === !1 ? !1 : Qt(i, e);
}, br = /* @__PURE__ */ ei.concat("iframe:not([inert]):not([inert] *)").join(","), Nt = function(e, i) {
  if (i = i || {}, !e) throw new Error("No node provided");
  return st.call(e, br) === !1 ? !1 : jt(i, e);
};
function Zt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var i = 0, n = Array(e); i < e; i++) n[i] = t[i];
  return n;
}
function yr(t) {
  if (Array.isArray(t)) return Zt(t);
}
function we(t, e, i, n, r, a, s) {
  try {
    var o = t[a](s), l = o.value;
  } catch (c) {
    i(c);
    return;
  }
  o.done ? e(l) : Promise.resolve(l).then(n, r);
}
function xe(t) {
  return function() {
    var e = this, i = arguments;
    return new Promise(function(n, r) {
      var a = t.apply(e, i);
      function s(l) {
        we(a, n, r, s, o, "next", l);
      }
      function o(l) {
        we(a, n, r, s, o, "throw", l);
      }
      s(void 0);
    });
  };
}
function Ee(t, e) {
  var i = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!i) {
    if (Array.isArray(t) || (i = li(t)) || e) {
      i && (t = i);
      var n = 0, r = function() {
      };
      return {
        s: r,
        n: function() {
          return n >= t.length ? { done: !0 } : {
            done: !1,
            value: t[n++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: r
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, s = !0, o = !1;
  return {
    s: function() {
      i = i.call(t);
    },
    n: function() {
      var l = i.next();
      return s = l.done, l;
    },
    e: function(l) {
      o = !0, a = l;
    },
    f: function() {
      try {
        s || i.return == null || i.return();
      } finally {
        if (o) throw a;
      }
    }
  };
}
function wr(t, e, i) {
  return (e = kr(e)) in t ? Object.defineProperty(t, e, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = i, t;
}
function xr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Er() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Se(t, e) {
  var i = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Te(t) {
  for (var e = 1; e < arguments.length; e++) {
    var i = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Se(Object(i), !0).forEach(function(n) {
      wr(t, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : Se(Object(i)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return t;
}
function vt() {
  var t, e, i = typeof Symbol == "function" ? Symbol : {}, n = i.iterator || "@@iterator", r = i.toStringTag || "@@toStringTag";
  function a(v, g, y, m) {
    var w = g && g.prototype instanceof o ? g : o, I = Object.create(w.prototype);
    return B(I, "_invoke", (function(O, A, _) {
      var R, k, F, K = 0, U = _ || [], P = !1, S = {
        p: 0,
        n: 0,
        v: t,
        a: f,
        f: f.bind(t, 4),
        d: function(h, b) {
          return R = h, k = 0, F = t, S.n = b, s;
        }
      };
      function f(h, b) {
        for (k = h, F = b, e = 0; !P && K && !E && e < U.length; e++) {
          var E, x = U[e], N = S.p, T = x[2];
          h > 3 ? (E = T === b) && (F = x[(k = x[4]) ? 5 : (k = 3, 3)], x[4] = x[5] = t) : x[0] <= N && ((E = h < 2 && N < x[1]) ? (k = 0, S.v = b, S.n = x[1]) : N < T && (E = h < 3 || x[0] > b || b > T) && (x[4] = h, x[5] = b, S.n = T, k = 0));
        }
        if (E || h > 1) return s;
        throw P = !0, b;
      }
      return function(h, b, E) {
        if (K > 1) throw TypeError("Generator is already running");
        for (P && b === 1 && f(b, E), k = b, F = E; (e = k < 2 ? t : F) || !P; ) {
          R || (k ? k < 3 ? (k > 1 && (S.n = -1), f(k, F)) : S.n = F : S.v = F);
          try {
            if (K = 2, R) {
              if (k || (h = "next"), e = R[h]) {
                if (!(e = e.call(R, F))) throw TypeError("iterator result is not an object");
                if (!e.done) return e;
                F = e.value, k < 2 && (k = 0);
              } else k === 1 && (e = R.return) && e.call(R), k < 2 && (F = TypeError("The iterator does not provide a '" + h + "' method"), k = 1);
              R = t;
            } else if ((e = (P = S.n < 0) ? F : O.call(A, S)) !== s) break;
          } catch (x) {
            R = t, k = 1, F = x;
          } finally {
            K = 1;
          }
        }
        return {
          value: e,
          done: P
        };
      };
    })(v, y, m), !0), I;
  }
  var s = {};
  function o() {
  }
  function l() {
  }
  function c() {
  }
  e = Object.getPrototypeOf;
  var d = [][n] ? e(e([][n]())) : (B(e = {}, n, function() {
    return this;
  }), e), u = c.prototype = o.prototype = Object.create(d);
  function p(v) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(v, c) : (v.__proto__ = c, B(v, r, "GeneratorFunction")), v.prototype = Object.create(u), v;
  }
  return l.prototype = c, B(u, "constructor", c), B(c, "constructor", l), l.displayName = "GeneratorFunction", B(c, r, "GeneratorFunction"), B(u), B(u, r, "Generator"), B(u, n, function() {
    return this;
  }), B(u, "toString", function() {
    return "[object Generator]";
  }), (vt = function() {
    return {
      w: a,
      m: p
    };
  })();
}
function B(t, e, i, n) {
  var r = Object.defineProperty;
  try {
    r({}, "", {});
  } catch {
    r = 0;
  }
  B = function(a, s, o, l) {
    function c(d, u) {
      B(a, d, function(p) {
        return this._invoke(d, u, p);
      });
    }
    s ? r ? r(a, s, {
      value: o,
      enumerable: !l,
      configurable: !l,
      writable: !l
    }) : a[s] = o : (c("next", 0), c("throw", 1), c("return", 2));
  }, B(t, e, i, n);
}
function Sr(t) {
  return yr(t) || xr(t) || li(t) || Er();
}
function Tr(t, e) {
  if (typeof t != "object" || !t) return t;
  var i = t[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(t, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function kr(t) {
  var e = Tr(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function li(t, e) {
  if (t) {
    if (typeof t == "string") return Zt(t, e);
    var i = {}.toString.call(t).slice(8, -1);
    return i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set" ? Array.from(t) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Zt(t, e) : void 0;
  }
}
var G = {
  getActiveTrap: function(e) {
    return e?.length > 0 ? e[e.length - 1] : null;
  },
  activateTrap: function(e, i) {
    i !== G.getActiveTrap(e) && G.pauseTrap(e);
    var n = e.indexOf(i);
    n === -1 || e.splice(n, 1), e.push(i);
  },
  deactivateTrap: function(e, i) {
    var n = e.indexOf(i);
    n !== -1 && e.splice(n, 1), G.unpauseTrap(e);
  },
  pauseTrap: function(e) {
    var i = G.getActiveTrap(e);
    i?._setPausedState(!0);
  },
  unpauseTrap: function(e) {
    var i = G.getActiveTrap(e);
    i && !i._isManuallyPaused() && i._setPausedState(!1);
  }
}, Ir = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Cr = function(e) {
  return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, mt = function(e) {
  return e?.key === "Tab" || e?.keyCode === 9;
}, Nr = function(e) {
  return mt(e) && !e.shiftKey;
}, Or = function(e) {
  return mt(e) && e.shiftKey;
}, ke = function(e) {
  return setTimeout(e, 0);
}, ft = function(e) {
  for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) n[r - 1] = arguments[r];
  return typeof e == "function" ? e.apply(void 0, n) : e;
}, It = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, Lr = [], _r = function(e, i) {
  var n = i?.document || document, r = i?.trapStack || Lr, a = Te({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Nr,
    isKeyBackward: Or
  }, i), s = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    adjacentElements: /* @__PURE__ */ new Set(),
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    delayInitialFocusTimer: void 0,
    recentNavEvent: void 0
  }, o, l = function(f, h, b) {
    return f && f[h] !== void 0 ? f[h] : a[b || h];
  }, c = function(f, h) {
    var b = typeof h?.composedPath == "function" ? h.composedPath() : void 0;
    return s.containerGroups.findIndex(function(E) {
      var x = E.container, N = E.tabbableNodes;
      return x.contains(f) || b?.includes(x) || N.find(function(T) {
        return T === f;
      });
    });
  }, d = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = h.hasFallback, E = b === void 0 ? !1 : b, x = h.params, N = x === void 0 ? [] : x, T = a[f];
    if (typeof T == "function" && (T = T.apply(void 0, Sr(N))), T === !0 && (T = void 0), !T) {
      if (T === void 0 || T === !1) return T;
      throw new Error("`".concat(f, "` was specified but was not a node, or did not return a node"));
    }
    var C = T;
    if (typeof T == "string") {
      try {
        C = n.querySelector(T);
      } catch (L) {
        throw new Error("`".concat(f, '` appears to be an invalid selector; error="').concat(L.message, '"'));
      }
      if (!C && !E)
        throw new Error("`".concat(f, "` as selector refers to no known node"));
    }
    return C;
  }, u = function() {
    var f = d("initialFocus", { hasFallback: !0 });
    if (f === !1) return !1;
    if (f === void 0 || f && !Nt(f, a.tabbableOptions))
      if (c(n.activeElement) >= 0) f = n.activeElement;
      else {
        var h = s.tabbableGroups[0];
        f = h && h.firstTabbableNode || d("fallbackFocus");
      }
    else f === null && (f = d("fallbackFocus"));
    if (!f) throw new Error("Your focus-trap needs to have at least one focusable element");
    return f;
  }, p = function() {
    if (s.containerGroups = s.containers.map(function(f) {
      var h = gr(f, a.tabbableOptions), b = oi(f, a.tabbableOptions), E = h.length > 0 ? h[0] : void 0, x = h.length > 0 ? h[h.length - 1] : void 0, N = b.find(function(C) {
        return lt(C);
      }), T = b.slice().reverse().find(function(C) {
        return lt(C);
      });
      return {
        container: f,
        tabbableNodes: h,
        focusableNodes: b,
        posTabIndexesFound: !!h.find(function(C) {
          return it(C) > 0;
        }),
        firstTabbableNode: E,
        lastTabbableNode: x,
        firstDomTabbableNode: N,
        lastDomTabbableNode: T,
        nextTabbableNode: function(L) {
          var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, q = h.indexOf(L);
          return q < 0 ? j ? b.slice(b.indexOf(L) + 1).find(function(D) {
            return lt(D);
          }) : b.slice(0, b.indexOf(L)).reverse().find(function(D) {
            return lt(D);
          }) : h[q + (j ? 1 : -1)];
        }
      };
    }), s.tabbableGroups = s.containerGroups.filter(function(f) {
      return f.tabbableNodes.length > 0;
    }), s.tabbableGroups.length <= 0 && !d("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (s.containerGroups.find(function(f) {
      return f.posTabIndexesFound;
    }) && s.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function(f) {
    var h = f.activeElement;
    if (h)
      return h.shadowRoot && h.shadowRoot.activeElement !== null ? v(h.shadowRoot) : h;
  }, g = function(f) {
    if (f !== !1 && f !== v(document)) {
      if (!f || !f.focus) {
        g(u());
        return;
      }
      f.focus({ preventScroll: !!a.preventScroll }), s.mostRecentlyFocusedNode = f, Ir(f) && f.select();
    }
  }, y = function(f) {
    var h = d("setReturnFocus", { params: [f] });
    return h || (h === !1 ? !1 : f);
  }, m = function(f) {
    var h = f.target, b = f.event, E = f.isBackward, x = E === void 0 ? !1 : E;
    h = h || It(b), p();
    var N = null;
    if (s.tabbableGroups.length > 0) {
      var T = c(h, b), C = T >= 0 ? s.containerGroups[T] : void 0;
      if (T < 0)
        x ? N = s.tabbableGroups[s.tabbableGroups.length - 1].lastTabbableNode : N = s.tabbableGroups[0].firstTabbableNode;
      else if (x) {
        var L = s.tabbableGroups.findIndex(function(Wt) {
          var Ut = Wt.firstTabbableNode;
          return h === Ut;
        });
        if (L < 0 && (C.container === h || Nt(h, a.tabbableOptions) && !lt(h, a.tabbableOptions) && !C.nextTabbableNode(h, !1)) && (L = T), L >= 0) {
          var j = L === 0 ? s.tabbableGroups.length - 1 : L - 1, q = s.tabbableGroups[j];
          N = it(h) >= 0 ? q.lastTabbableNode : q.lastDomTabbableNode;
        } else mt(b) || (N = C.nextTabbableNode(h, !1));
      } else {
        var D = s.tabbableGroups.findIndex(function(Wt) {
          var Ut = Wt.lastTabbableNode;
          return h === Ut;
        });
        if (D < 0 && (C.container === h || Nt(h, a.tabbableOptions) && !lt(h, a.tabbableOptions) && !C.nextTabbableNode(h)) && (D = T), D >= 0) {
          var zt = D === s.tabbableGroups.length - 1 ? 0 : D + 1, X = s.tabbableGroups[zt];
          N = it(h) >= 0 ? X.firstTabbableNode : X.firstDomTabbableNode;
        } else mt(b) || (N = C.nextTabbableNode(h));
      }
    } else N = d("fallbackFocus");
    return N;
  }, w = function(f) {
    if (!(c(It(f), f) >= 0)) {
      if (ft(a.clickOutsideDeactivates, f)) {
        o.deactivate({ returnFocus: a.returnFocusOnDeactivate });
        return;
      }
      ft(a.allowOutsideClick, f) || f.preventDefault();
    }
  }, I = function(f) {
    var h = It(f), b = c(h, f) >= 0;
    if (b || h instanceof Document)
      b && (s.mostRecentlyFocusedNode = h);
    else {
      f.stopImmediatePropagation();
      var E, x = !0;
      if (s.mostRecentlyFocusedNode)
        if (it(s.mostRecentlyFocusedNode) > 0) {
          var N = c(s.mostRecentlyFocusedNode), T = s.containerGroups[N].tabbableNodes;
          if (T.length > 0) {
            var C = T.findIndex(function(L) {
              return L === s.mostRecentlyFocusedNode;
            });
            C >= 0 && (a.isKeyForward(s.recentNavEvent) ? C + 1 < T.length && (E = T[C + 1], x = !1) : C - 1 >= 0 && (E = T[C - 1], x = !1));
          }
        } else s.containerGroups.some(function(L) {
          return L.tabbableNodes.some(function(j) {
            return it(j) > 0;
          });
        }) || (x = !1);
      else x = !1;
      x && (E = m({
        target: s.mostRecentlyFocusedNode,
        isBackward: a.isKeyBackward(s.recentNavEvent)
      })), g(E || s.mostRecentlyFocusedNode || u());
    }
    s.recentNavEvent = void 0;
  }, O = function(f) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    s.recentNavEvent = f;
    var b = m({
      event: f,
      isBackward: h
    });
    b && (mt(f) && f.preventDefault(), g(b));
  }, A = function(f) {
    (a.isKeyForward(f) || a.isKeyBackward(f)) && O(f, a.isKeyBackward(f));
  }, _ = function(f) {
    Cr(f) && ft(a.escapeDeactivates, f) !== !1 && (f.preventDefault(), o.deactivate());
  }, R = function(f) {
    c(It(f), f) >= 0 || ft(a.clickOutsideDeactivates, f) || ft(a.allowOutsideClick, f) || (f.preventDefault(), f.stopImmediatePropagation());
  }, k = function() {
    if (!s.active) return Promise.resolve();
    G.activateTrap(r, o);
    var f;
    return a.delayInitialFocus ? f = new Promise(function(h) {
      s.delayInitialFocusTimer = ke(function() {
        g(u()), h();
      });
    }) : (f = Promise.resolve(), g(u())), n.addEventListener("focusin", I, !0), n.addEventListener("mousedown", w, {
      capture: !0,
      passive: !1
    }), n.addEventListener("touchstart", w, {
      capture: !0,
      passive: !1
    }), n.addEventListener("click", R, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", A, {
      capture: !0,
      passive: !1
    }), n.addEventListener("keydown", _), f;
  }, F = function(f) {
    s.active && !s.paused && o._setSubtreeIsolation(!1), s.adjacentElements.clear(), s.alreadySilent.clear();
    var h = /* @__PURE__ */ new Set(), b = /* @__PURE__ */ new Set(), E = Ee(f), x;
    try {
      for (E.s(); !(x = E.n()).done; ) {
        var N = x.value;
        h.add(N);
        for (var T = typeof ShadowRoot < "u" && N.getRootNode() instanceof ShadowRoot, C = N; C; ) {
          h.add(C);
          var L = C.parentElement, j = [];
          L ? j = L.children : !L && T && (j = C.getRootNode().children, L = C.getRootNode().host, T = typeof ShadowRoot < "u" && L.getRootNode() instanceof ShadowRoot);
          var q = Ee(j), D;
          try {
            for (q.s(); !(D = q.n()).done; ) {
              var zt = D.value;
              b.add(zt);
            }
          } catch (X) {
            q.e(X);
          } finally {
            q.f();
          }
          C = L;
        }
      }
    } catch (X) {
      E.e(X);
    } finally {
      E.f();
    }
    h.forEach(function(X) {
      b.delete(X);
    }), s.adjacentElements = b;
  }, K = function() {
    if (s.active)
      return n.removeEventListener("focusin", I, !0), n.removeEventListener("mousedown", w, !0), n.removeEventListener("touchstart", w, !0), n.removeEventListener("click", R, !0), n.removeEventListener("keydown", A, !0), n.removeEventListener("keydown", _), o;
  }, U = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(function(f) {
    f.some(function(h) {
      return Array.from(h.removedNodes).some(function(b) {
        return b === s.mostRecentlyFocusedNode;
      });
    }) && g(u());
  }) : void 0, P = function() {
    U && (U.disconnect(), s.active && !s.paused && s.containers.map(function(f) {
      U.observe(f, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return s.active;
    },
    get paused() {
      return s.paused;
    },
    activate: function(f) {
      if (s.active) return this;
      var h = l(f, "onActivate"), b = l(f, "onPostActivate"), E = l(f, "checkCanFocusTrap"), x = G.getActiveTrap(r), N = !1;
      if (x && !x.paused) {
        var T;
        (T = x._setSubtreeIsolation) === null || T === void 0 || T.call(x, !1), N = !0;
      }
      try {
        E || p(), s.active = !0, s.paused = !1, s.nodeFocusedBeforeActivation = v(n), h?.();
        var C = /* @__PURE__ */ (function() {
          var j = xe(/* @__PURE__ */ vt().m(function q() {
            return vt().w(function(D) {
              for (; ; ) switch (D.n) {
                case 0:
                  return E && p(), D.n = 1, k();
                case 1:
                  o._setSubtreeIsolation(!0), P(), b?.();
                case 2:
                  return D.a(2);
              }
            }, q);
          }));
          return function() {
            return j.apply(this, arguments);
          };
        })();
        if (E)
          return E(s.containers.concat()).then(C, C), this;
        C();
      } catch (j) {
        if (x === G.getActiveTrap(r) && N) {
          var L;
          (L = x._setSubtreeIsolation) === null || L === void 0 || L.call(x, !0);
        }
        throw j;
      }
      return this;
    },
    deactivate: function(f) {
      if (!s.active) return this;
      var h = Te({
        onDeactivate: a.onDeactivate,
        onPostDeactivate: a.onPostDeactivate,
        checkCanReturnFocus: a.checkCanReturnFocus
      }, f);
      clearTimeout(s.delayInitialFocusTimer), s.delayInitialFocusTimer = void 0, s.paused || o._setSubtreeIsolation(!1), s.alreadySilent.clear(), K(), s.active = !1, s.paused = !1, P(), G.deactivateTrap(r, o);
      var b = l(h, "onDeactivate"), E = l(h, "onPostDeactivate"), x = l(h, "checkCanReturnFocus"), N = l(h, "returnFocus", "returnFocusOnDeactivate");
      b?.();
      var T = function() {
        ke(function() {
          N && g(y(s.nodeFocusedBeforeActivation)), E?.();
        });
      };
      return N && x ? (x(y(s.nodeFocusedBeforeActivation)).then(T, T), this) : (T(), this);
    },
    pause: function(f) {
      return s.active ? (s.manuallyPaused = !0, this._setPausedState(!0, f)) : this;
    },
    unpause: function(f) {
      return s.active ? (s.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, f)) : this;
    },
    updateContainerElements: function(f) {
      return s.containers = [].concat(f).filter(Boolean).map(function(h) {
        return typeof h == "string" ? n.querySelector(h) : h;
      }), a.isolateSubtrees && F(s.containers), s.active && (p(), s.paused || o._setSubtreeIsolation(!0)), P(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: { value: function() {
      return s.manuallyPaused;
    } },
    _setPausedState: { value: function(f, h) {
      if (s.paused === f) return this;
      if (s.paused = f, f) {
        var b = l(h, "onPause"), E = l(h, "onPostPause");
        b?.(), K(), o._setSubtreeIsolation(!1), P(), E?.();
      } else {
        var x = l(h, "onUnpause"), N = l(h, "onPostUnpause");
        x?.(), (/* @__PURE__ */ (function() {
          var T = xe(/* @__PURE__ */ vt().m(function C() {
            return vt().w(function(L) {
              for (; ; ) switch (L.n) {
                case 0:
                  return p(), L.n = 1, k();
                case 1:
                  o._setSubtreeIsolation(!0), P(), N?.();
                case 2:
                  return L.a(2);
              }
            }, C);
          }));
          return function() {
            return T.apply(this, arguments);
          };
        })())();
      }
      return this;
    } },
    _setSubtreeIsolation: { value: function(f) {
      a.isolateSubtrees && s.adjacentElements.forEach(function(h) {
        var b;
        f ? a.isolateSubtrees === "aria-hidden" ? ((h.ariaHidden === "true" || ((b = h.getAttribute("aria-hidden")) === null || b === void 0 ? void 0 : b.toLowerCase()) === "true") && s.alreadySilent.add(h), h.setAttribute("aria-hidden", "true")) : ((h.inert || h.hasAttribute("inert")) && s.alreadySilent.add(h), h.setAttribute("inert", !0)) : s.alreadySilent.has(h) || (a.isolateSubtrees === "aria-hidden" ? h.removeAttribute("aria-hidden") : h.removeAttribute("inert"));
      });
    } }
  }), o.updateContainerElements(e), o;
};
function Ar(t) {
  let e, i;
  window.addEventListener("focusin", () => {
    e = i, i = document.activeElement;
  }), t.magic("focus", (n) => {
    let r = n;
    return {
      __noscroll: !1,
      __wrapAround: !1,
      within(a) {
        return r = a, this;
      },
      withoutScrolling() {
        return this.__noscroll = !0, this;
      },
      noscroll() {
        return this.__noscroll = !0, this;
      },
      withWrapAround() {
        return this.__wrapAround = !0, this;
      },
      wrap() {
        return this.withWrapAround();
      },
      focusable(a) {
        return Nt(a);
      },
      previouslyFocused() {
        return e;
      },
      lastFocused() {
        return e;
      },
      focused() {
        return i;
      },
      focusables() {
        return Array.isArray(r) ? r : oi(r, { displayCheck: "none" });
      },
      all() {
        return this.focusables();
      },
      isFirst(a) {
        let s = this.all();
        return s[0] && s[0].isSameNode(a);
      },
      isLast(a) {
        let s = this.all();
        return s.length && s.slice(-1)[0].isSameNode(a);
      },
      getFirst() {
        return this.all()[0];
      },
      getLast() {
        return this.all().slice(-1)[0];
      },
      getNext() {
        let a = this.all(), s = document.activeElement;
        if (a.indexOf(s) !== -1)
          return this.__wrapAround && a.indexOf(s) === a.length - 1 ? a[0] : a[a.indexOf(s) + 1];
      },
      getPrevious() {
        let a = this.all(), s = document.activeElement;
        if (a.indexOf(s) !== -1)
          return this.__wrapAround && a.indexOf(s) === 0 ? a.slice(-1)[0] : a[a.indexOf(s) - 1];
      },
      first() {
        this.focus(this.getFirst());
      },
      last() {
        this.focus(this.getLast());
      },
      next() {
        this.focus(this.getNext());
      },
      previous() {
        this.focus(this.getPrevious());
      },
      prev() {
        return this.previous();
      },
      focus(a) {
        a && setTimeout(() => {
          a.hasAttribute("tabindex") || a.setAttribute("tabindex", "0"), a.focus({ preventScroll: this.__noscroll });
        });
      }
    };
  }), t.directive("trap", t.skipDuringClone((n, { expression: r, modifiers: a }, { effect: s, evaluateLater: o, cleanup: l }) => {
    let c = o(r), d = !1, u = {
      escapeDeactivates: !1,
      allowOutsideClick: !0,
      fallbackFocus: () => n
    }, p = () => {
    };
    if (a.includes("noautofocus")) u.initialFocus = !1;
    else {
      let m = n.querySelector("[autofocus]");
      m && (u.initialFocus = m);
    }
    a.includes("inert") && (u.onPostActivate = () => {
      t.nextTick(() => {
        p = Ie(n);
      });
    });
    let v = _r(n, u), g = () => {
    };
    const y = () => {
      p(), p = () => {
      }, g(), g = () => {
      }, v.deactivate({ returnFocus: !a.includes("noreturn") });
    };
    s(() => c((m) => {
      d !== m && (m && !d && (a.includes("noscroll") && (g = Fr()), setTimeout(() => {
        v.activate();
      }, 15)), !m && d && y(), d = !!m);
    })), l(y);
  }, (n, { expression: r, modifiers: a }, { evaluate: s }) => {
    a.includes("inert") && s(r) && Ie(n);
  }));
}
function Ie(t) {
  let e = [];
  return ci(t, (i) => {
    let n = i.hasAttribute("aria-hidden");
    i.setAttribute("aria-hidden", "true"), e.push(() => n || i.removeAttribute("aria-hidden"));
  }), () => {
    for (; e.length; ) e.pop()();
  };
}
function ci(t, e) {
  t.isSameNode(document.body) || !t.parentNode || Array.from(t.parentNode.children).forEach((i) => {
    i.isSameNode(t) ? ci(t.parentNode, e) : e(i);
  });
}
function Fr() {
  let t = document.documentElement.style.overflow, e = document.documentElement.style.paddingRight, i = window.innerWidth - document.documentElement.clientWidth, n = window.getComputedStyle(document.documentElement).scrollbarGutter;
  return document.documentElement.style.overflow = "hidden", n && n !== "auto" ? () => {
    document.documentElement.style.overflow = t;
  } : (document.documentElement.style.paddingRight = `${i}px`, () => {
    document.documentElement.style.overflow = t, document.documentElement.style.paddingRight = e;
  });
}
var $r = Ar;
function Rr(t) {
  t.directive("intersect", t.skipDuringClone((e, { value: i, expression: n, modifiers: r }, { evaluateLater: a, cleanup: s }) => {
    let o = a(n), l = Mr(r), c = {
      rootMargin: qr(r),
      threshold: l,
      root: r.includes("parent") ? e.parentElement : null
    };
    if (r.includes("dwell")) {
      Dr(e, i, r, o, s, c, l);
      return;
    }
    let d = new IntersectionObserver((u) => {
      u.forEach((p) => {
        p.isIntersecting !== (i === "leave") && (o(), r.includes("once") && d.disconnect());
      });
    }, c);
    d.observe(e), s(() => {
      d.disconnect();
    });
  }));
}
function Dr(t, e, i, n, r, a, s) {
  let o, l, c = !1, d = !1, u = Pr(i), p, v = () => {
    clearTimeout(o), o = void 0;
  }, g = () => {
    d = !1, !(!l || document.hidden || !Ct(l, e, s)) && (c = !0, n(), i.includes("once") && (p.disconnect(), document.removeEventListener("visibilitychange", O)));
  }, y = () => {
    p && p.disconnect(), p = new IntersectionObserver(I, a), p.observe(t);
  }, m = () => {
    if (o = void 0, document.hidden) return;
    let A = p.takeRecords();
    if (A.some((_) => !Ct(_, e, s))) {
      I(A);
      return;
    }
    d = !0, l = void 0, y();
  }, w = () => {
    o !== void 0 || c || document.hidden || !l || Ct(l, e, s) && (o = setTimeout(m, u));
  }, I = (A) => {
    A.forEach((_) => {
      if (l = _, !Ct(_, e, s)) {
        v(), c = !1, d = !1;
        return;
      }
      if (d) {
        g();
        return;
      }
      w();
    });
  }, O = () => {
    if (document.hidden) {
      v(), l = void 0, c = !1, d = !1, p.disconnect();
      return;
    }
    y();
  };
  y(), document.addEventListener("visibilitychange", O), r(() => {
    v(), p.disconnect(), document.removeEventListener("visibilitychange", O);
  });
}
function Ct(t, e, i) {
  let n = i === 0 ? t.isIntersecting : t.isIntersecting && t.intersectionRatio >= i;
  return e === "leave" ? !n : n;
}
function Pr(t) {
  let e = (t[t.indexOf("dwell") + 1] || "").match(/^([0-9]+)(ms)?$/);
  return e ? Number(e[1]) : 250;
}
function Mr(t) {
  if (t.includes("full")) return 0.99;
  if (t.includes("half")) return 0.5;
  if (!t.includes("threshold")) return 0;
  let e = t[t.indexOf("threshold") + 1];
  return e === "100" ? 1 : e === "0" ? 0 : +`.${e}`;
}
function jr(t) {
  let e = t.match(/^(-?[0-9]+)(px|%)?$/);
  return e ? e[1] + (e[2] || "px") : void 0;
}
function qr(t) {
  const e = "margin", i = "0px 0px 0px 0px", n = t.indexOf(e);
  if (n === -1) return i;
  let r = [];
  for (let a = 1; a < 5; a++) r.push(jr(t[n + a] || ""));
  return r = r.filter((a) => a !== void 0), r.length ? r.join(" ").trim() : i;
}
var Br = Rr;
function ae(t, e, i) {
  di();
  let n = ui(i), r = typeof e == "string" ? Kr(e) : e;
  return window.Alpine && window.Alpine.closestDataStack && !t._x_dataStack && (r._x_dataStack = window.Alpine.closestDataStack(t), r._x_dataStack && window.Alpine.cloneNode(t, r)), n.patch(t, r), t;
}
function Vr(t, e, i, n = {}) {
  di();
  let r = ui(n), a = t.parentNode, s = new bt(t, e), o = typeof i == "string" ? (() => {
    let u = document.createElement("div");
    return u.insertAdjacentHTML("beforeend", i), u;
  })() : i, l = document.createComment("[morph-start]"), c = document.createComment("[morph-end]");
  o.insertBefore(l, o.firstChild), o.appendChild(c);
  let d = new bt(l, c);
  window.Alpine && window.Alpine.closestDataStack && (o._x_dataStack = window.Alpine.closestDataStack(a), o._x_dataStack && window.Alpine.cloneNode(a, o)), r.patchChildren(s, d);
}
function ui(t = {}) {
  let e = (r) => r.getAttribute("key"), i = () => {
  }, n = {
    key: t.key || e,
    lookahead: t.lookahead || !1,
    updating: t.updating || i,
    updated: t.updated || i,
    removing: t.removing || i,
    removed: t.removed || i,
    adding: t.adding || i,
    added: t.added || i
  };
  return n.patch = function(r, a) {
    if (n.differentElementNamesTypesOrKeys(r, a)) return n.swapElements(r, a);
    let s = !1, o = !1, l = (c) => n.skipUntilCondition = c;
    if (!Hr(n.updating, () => o = !0, l, r, a, () => s = !0)) {
      if (r.nodeType === 1 && window.Alpine && (window.Alpine.cloneNode(r, a), r._x_teleport && a._x_teleport && n.patch(r._x_teleport, a._x_teleport)), zr(a)) {
        n.patchNodeValue(r, a), n.updated(r, a);
        return;
      }
      s || n.patchAttributes(r, a), n.updated(r, a), o || n.patchChildren(r, a);
    }
  }, n.differentElementNamesTypesOrKeys = function(r, a) {
    return r.nodeType != a.nodeType || r.nodeName != a.nodeName || n.getKey(r) != n.getKey(a);
  }, n.swapElements = function(r, a) {
    if (ht(n.removing, r)) return;
    let s = a.cloneNode(!0);
    ht(n.adding, s) || (r.replaceWith(s), n.removed(r), n.added(s));
  }, n.patchNodeValue = function(r, a) {
    let s = a.nodeValue;
    r.nodeValue !== s && (r.nodeValue = s);
  }, n.patchAttributes = function(r, a) {
    if (r._x_transitioning || r._x_isShown && !a._x_isShown || !r._x_isShown && a._x_isShown) return;
    let s = Array.from(r.attributes), o = Array.from(a.attributes);
    for (let l = s.length - 1; l >= 0; l--) {
      let c = s[l].name;
      a.hasAttribute(c) || (c === "open" && r.nodeName === "DIALOG" && r.open ? r.close() : r.removeAttribute(c));
    }
    for (let l = o.length - 1; l >= 0; l--) {
      let c = o[l].name, d = o[l].value;
      r.getAttribute(c) !== d && r.setAttribute(c, d);
    }
  }, n.patchChildren = function(r, a) {
    let s = n.keyToMap(r.children), o = {}, l = Ne(a), c = Ne(r);
    for (; l; ) {
      Wr(l, c);
      let u = n.getKey(l), p = n.getKey(c);
      if (n.skipUntilCondition) {
        let m = !c || n.skipUntilCondition(c), w = !l || n.skipUntilCondition(l);
        if (m && w) n.skipUntilCondition = null;
        else {
          m || (c = c && M(r, c)), w || (l = l && M(a, l));
          continue;
        }
      }
      if (!c)
        if (u && o[u]) {
          let m = o[u];
          r.appendChild(m), c = m, p = n.getKey(c);
        } else {
          if (!ht(n.adding, l)) {
            let m = l.cloneNode(!0);
            r.appendChild(m), n.added(m);
          }
          l = M(a, l);
          continue;
        }
      let v = (m) => m && m.nodeType === 8 && m.textContent === "[if BLOCK]><![endif]", g = (m) => m && m.nodeType === 8 && m.textContent === "[if ENDBLOCK]><![endif]";
      if (v(l) && v(c)) {
        let m = 0, w = c;
        for (; c; ) {
          let k = M(r, c);
          if (v(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            c = k;
            break;
          }
          c = k;
        }
        let I = c;
        m = 0;
        let O = l;
        for (; l; ) {
          let k = M(a, l);
          if (v(k)) m++;
          else if (g(k) && m > 0) m--;
          else if (g(k) && m === 0) {
            l = k;
            break;
          }
          l = k;
        }
        let A = l, _ = new bt(w, I), R = new bt(O, A);
        n.patchChildren(_, R);
        continue;
      }
      if (c.nodeType === 1 && n.lookahead && !c.isEqualNode(l)) {
        let m = M(a, l), w = !1;
        for (; !w && m; )
          m.nodeType === 1 && c.isEqualNode(m) && (w = !0, c = n.addNodeBefore(r, l, c), p = n.getKey(c)), m = M(a, m);
      }
      if (u !== p) {
        if (!u && p) {
          o[p] = c, c = n.addNodeBefore(r, l, c), o[p].remove(), c = M(r, c), l = M(a, l);
          continue;
        }
        if (u && !p && s[u] && (c.replaceWith(s[u]), c = s[u], p = n.getKey(c)), u && p) {
          let m = s[u];
          if (m)
            o[p] = c, c.replaceWith(m), c = m, p = n.getKey(c);
          else {
            o[p] = c, c = n.addNodeBefore(r, l, c), o[p].remove(), c = M(r, c), l = M(a, l);
            continue;
          }
        }
      }
      let y = c && M(r, c);
      n.patch(c, l), c._x_lastRenderedEl && (y = M(r, c._x_lastRenderedEl)), l = l && M(a, l), c = y;
    }
    let d = [];
    for (; c; )
      ht(n.removing, c) || d.push(c), c = M(r, c);
    for (; d.length; ) {
      let u = d.shift();
      u.remove(), n.removed(u);
    }
  }, n.getKey = function(r) {
    return r && r.nodeType === 1 && n.key(r);
  }, n.keyToMap = function(r) {
    let a = {};
    for (let s of r) {
      let o = n.getKey(s);
      o && (a[o] = s);
    }
    return a;
  }, n.addNodeBefore = function(r, a, s) {
    if (!ht(n.adding, a)) {
      let o = a.cloneNode(!0);
      return r.insertBefore(o, s), n.added(o), o;
    }
    return a;
  }, n;
}
ae.step = () => {
};
ae.log = () => {
};
function ht(t, ...e) {
  let i = !1;
  return t(...e, () => i = !0), i;
}
function Hr(t, e, i, ...n) {
  let r = !1;
  return t(...n, () => r = !0, e, i), r;
}
var Ce = !1;
function Kr(t) {
  const e = document.createElement("template");
  return e.innerHTML = t, e.content.firstElementChild;
}
function zr(t) {
  return t.nodeType === 3 || t.nodeType === 8;
}
var bt = class {
  constructor(t, e) {
    this.startComment = t, this.endComment = e;
  }
  get children() {
    let t = [], e = this.startComment.nextSibling;
    for (; e && e !== this.endComment; )
      t.push(e), e = e.nextSibling;
    return t;
  }
  appendChild(t) {
    this.endComment.before(t);
  }
  get firstChild() {
    let t = this.startComment.nextSibling;
    if (t !== this.endComment)
      return t;
  }
  nextNode(t) {
    let e = t.nextSibling;
    if (e !== this.endComment)
      return e;
  }
  insertBefore(t, e) {
    return e.before(t), t;
  }
};
function Ne(t) {
  return t.firstChild;
}
function M(t, e) {
  let i;
  return t instanceof bt ? i = t.nextNode(e) : i = e.nextSibling, i;
}
function di() {
  if (Ce) return;
  Ce = !0;
  let t = Element.prototype.setAttribute, e = document.createElement("div");
  Element.prototype.setAttribute = function(n, r) {
    if (!n.includes("@")) return t.call(this, n, r);
    let a = r.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
    e.innerHTML = `<span ${n}="${a}"></span>`;
    let s = e.firstElementChild.getAttributeNode(n);
    e.firstElementChild.removeAttributeNode(s), this.setAttributeNode(s);
  };
}
function Wr(t, e) {
  let i = e && e._x_bindings && e._x_bindings.id;
  i && t.setAttribute && (t.setAttribute("id", i), t.id = i);
}
function Ur(t) {
  t.morph = ae, t.morphBetween = Vr;
}
var Gr = Ur, Yr = (t, e) => {
  let i;
  const n = /* @__PURE__ */ new Set();
  return function(r, a) {
    i && clearTimeout(i), r.forEach(({ target: s }) => n.add(s)), i = setTimeout(() => {
      t(n, a), i = null;
    }, e);
  };
}, Jr = (t) => {
  t.forEach((e) => Xr(e)), t.clear();
}, Xr = (t) => {
  const e = (s) => t.setAttribute("sizes", (s | 0) + "px");
  let i = 0, n = 0, r = t;
  for (; i < 100 && r; )
    i = r.offsetWidth, n = r.offsetHeight, r = r.parentNode;
  if (getComputedStyle(t).objectFit !== "cover") return e(i);
  const a = Number(t.getAttribute("width")) / Number(t.getAttribute("height"));
  if (!a || i / n >= a + 0.1) return e(i);
  e(n * a);
}, tt = new ResizeObserver(Yr(Jr, 800)), Oe = (t, e, i) => {
  if (e) return Zr(t);
  if (i) return Qr(t, i);
  throw new TypeError("Invalid options");
}, Qr = (t, e) => (t = new URL(t, document.baseURI).href, t.includes("localhost") ? () => t : (i) => (e + t).replace("{width}", String(i))), Zr = (t) => {
  if (t.includes("{width}")) return (e) => t.replaceAll("{width}", String(e));
  if (_e.test(t)) {
    const e = t.replace(_e, "_{width}x$1");
    return (i) => e.replaceAll("{width}", String(i));
  }
  return (e) => {
    const i = new URL(t, document.baseURI);
    return i.searchParams.set("width", String(e)), i.href;
  };
}, ta = [
  180,
  360,
  540,
  720,
  900,
  1080,
  1296,
  1512,
  1728,
  1944,
  2160,
  2376,
  2592,
  2808,
  3024
], Le = (t, e = 1 / 0) => ta.filter((i) => i <= e).map((i) => `${t(i)} ${i}w`).join(","), _e = /_\d+x(\.jpg|\.png)/;
function ea(t) {
  const { autoSize: e = !0, shopify: i = !1, maxSize: n = 0, cloudURL: r = "" } = ia(t) ?? {};
  return (a) => {
    a.directive("rias", (o, { expression: l }, { effect: c, evaluateLater: d, cleanup: u }) => {
      if (!(o instanceof HTMLImageElement)) return console.warn("x-rias only works on img elements");
      if (u(() => tt.unobserve(o)), !l) return e && tt.observe(o);
      const p = d(l);
      c(() => {
        p((v) => {
          if (!v || typeof v != "string") return;
          const g = Oe(v, i, r), y = n || Number(o.dataset.maxSize) || 1 / 0, m = g(Math.min(y, 360)), w = Le(g, y);
          a.mutateDom(() => {
            o.src = m, o.srcset = w, o.loading = o.loading == "eager" ? "eager" : "lazy", (e || o.dataset.sizes == "auto") && tt.observe(o);
          });
        });
      });
    });
    const s = {
      srcset(o) {
        return Le(Oe(o, i, r), n || 1 / 0);
      },
      observe: tt.observe.bind(tt),
      unobserve: tt.unobserve.bind(tt)
    };
    a.magic("rias", () => s);
  };
}
var ia = (t) => {
  if (typeof t == "string") return { cloudURL: `https://res.cloudinary.com/${t}/image/fetch/f_auto,q_80,w_{width}/` };
  if (typeof t == "object") return {
    ...t,
    cloudURL: t.key ? `https://res.cloudinary.com/${t.key}/image/fetch/f_auto,q_80,w_{width}/` : ""
  };
}, na = (t) => {
  t.addRootSelector(() => `[${t.prefixed("data-async")}]`);
  const e = "data-async", i = t.prefixed("ignore"), n = {}, r = /* @__PURE__ */ new WeakSet(), a = (s, { expression: o }, { evaluateLater: l, evaluate: c, cleanup: d }) => {
    r.has(s) || (r.add(s), l(o)((u) => {
      if (typeof u != "object" || u === null) throw new Error(`alpine.js Async directive expected an object, but received: ${typeof u}`);
      [!0, void 0].includes(u) && (u = {});
      const p = t.reactive(u), v = t.addScopeToNode(s, p);
      p.init && c(p.init), d(() => {
        p.destroy && c(p.destroy), v();
      }), delete s._x_ignore, s.removeAttribute(i), t.initTree(s);
    }, { scope: n }));
  };
  a.inline = (s, { expression: o }) => {
    r.has(s) || (s._x_ignore = !0, s.setAttribute(i, ""));
  }, t.directive(e, a).before("ignore"), t.asyncData = (s, o) => {
    n[s] = async (...l) => {
      const [c, d] = o.split("?");
      try {
        const u = await import(c);
        if (d && d in u) return u[d](...l);
        if (s in u) return u[s](...l);
        if (u.default && typeof u.default == "function") return u.default(...l);
        if (typeof u == "function") return u(...l);
        throw new Error(`Async Data: Module ${o} does not export a function named ${s}, or a default function.`);
      } catch (u) {
        return console.error("Async Data Loader Error while looking for:", s, o), console.error(u), {};
      }
    };
  };
}, ra = (t) => {
  t.directive("clickable", (n, { expression: r }, { cleanup: a }) => {
    const s = n.querySelector(r || "a, button");
    if (!s) return console.warn(`x-clickable: No target found for selector ${r || "a, button"}`);
    const o = function(l) {
      const c = l.target;
      !(c instanceof HTMLElement) || e(c, n) !== n || i(s, l.constructor, l);
    };
    a(t.bind(n, {
      "@click": o,
      "@auxclick": o
    }));
  });
  const e = (n, r) => t.findClosest(n, (a) => a.matches("a, button, input, select") || a === r), i = (n, r = MouseEvent, a) => n.dispatchEvent(new r("click", a));
}, aa = class {
  el;
  details;
  get id() {
    return this.el.id;
  }
  closing = !1;
  opening = !1;
  backdrop;
  keyboard;
  constructor(t, e, i) {
    this.el = t, this.details = i, this.backdrop = e.backdrop, this.keyboard = e.keyboard;
  }
  withDetails(t) {
    return t && (this.details = t), this;
  }
  async open() {
    return this.el.open ? this : (this.opening = !0, this.el.dispatchEvent(new CustomEvent("dialog-opening", {
      detail: this,
      bubbles: !0
    })), this.el.showModal(), await this.el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 }).finished, this.el.dispatchEvent(new CustomEvent("dialog-opened", {
      detail: this,
      bubbles: !0
    })), this.opening = !1, this);
  }
  async close() {
    return this.el.open ? (this.closing = !0, this.el.dispatchEvent(new CustomEvent("dialog-closing", {
      detail: this,
      bubbles: !0
    })), await this.el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200 }).finished, this.el.close(), this.el.dispatchEvent(new CustomEvent("dialog-closed", {
      detail: this,
      bubbles: !0
    })), this.closing = !1, this) : this;
  }
}, sa = class extends EventTarget {
  Alpine;
  availableDialogs = /* @__PURE__ */ new Map();
  active = null;
  constructor(t) {
    super(), this.Alpine = t;
  }
  get isActive() {
    return !!this.active;
  }
  get id() {
    return this.active?.el.id;
  }
  get details() {
    return this.active?.details;
  }
  open(t, e) {
    if (t === this.active?.el.id) return this;
    this.active && this.close(this.active);
    const i = this.availableDialogs.get(t) ?? null;
    return i ? (this.active = i, i.withDetails(e).open(), this.dispatchEvent(new CustomEvent("dialog-opened", { detail: i })), this) : (console.error(`Modal with id "${t}" does not exist`), this);
  }
  close(t) {
    const e = t ?? this.active;
    return e ? (e.close().then((i) => i === this.active && (this.active = null)), this.dispatchEvent(new CustomEvent("dialog-closed", { detail: e })), this) : (console.log(t, e, "there is no active"), this);
  }
  setOptions(t) {
    return this.active && Object.assign(this.active, t), this;
  }
  isRegistered(t) {
    return this.availableDialogs.has(t);
  }
  unregister(t) {
    return this.availableDialogs.delete(t), this.active?.id === t && (this.active = null), this;
  }
  create(t, e, i) {
    const n = this.Alpine.reactive(new aa(t, e, i));
    return this.availableDialogs.set(n.id, n), n;
  }
}, oa = (t) => {
  const e = new sa(t);
  t.addRootSelector(() => `[${t.prefixed("dialog")}]`), t.directive("dialog", (i, { expression: n }, { evaluate: r, cleanup: a }) => {
    if (!(i instanceof HTMLDialogElement)) return console.error("x-modal must be on a <dialog> element", i);
    const s = i.id;
    console.assert(!!s, "x-dialog element must have an ID: %o", i);
    const { backdrop: o = !0, keyboard: l = !0 } = n ? r(n) : {}, c = e.create(i, {
      backdrop: o,
      keyboard: l
    });
    a(t.addScopeToNode(i, { $dialog: c })), a(e.unregister.bind(e, s)), a(t.bind(i, {
      "@click.self"() {
        c.backdrop && e.close(c);
      },
      "@cancel.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      "@dialog-closed.self"(d) {
        d.detail === c && c === e.active && (e.active = null, e.dispatchEvent(new CustomEvent("dialog-closed", { detail: c })));
      },
      "@keydown.escape.prevent.stop"() {
        c.keyboard && e.close(c);
      },
      ":class"() {
        return {
          "dialog-out backdrop:animate-fade-out": c.closing,
          "dialog-in backdrop:animate-fade-in": c.opening
        };
      }
    }));
  }), t.magic("dialogs", () => e), t.$dialogs = e;
}, Ot = /* @__PURE__ */ (function(t) {
  return t.Up = "up", t.Down = "down", t;
})(Ot || {}), la = (t) => {
  const e = /* @__PURE__ */ new Set(), i = t.reactive({
    previous: window.scrollY,
    current: window.scrollY,
    nearTop: window.scrollY < 120,
    direction: Ot.Up,
    onScroll: (r) => (e.add(r), () => e.delete(r))
  });
  let n;
  i.onScroll((r) => {
    const a = r.current > r.previous ? Ot.Down : Ot.Up;
    a !== i.direction ? n ??= setTimeout(() => i.direction = a, 200) : (clearTimeout(n), n = void 0);
  }), window.addEventListener("scroll", () => {
    i.previous = i.current, i.current = window.scrollY, i.nearTop = window.scrollY <= 90 ? !0 : window.scrollY >= 120 ? !1 : i.nearTop, e.forEach((r) => r(i));
  }, { passive: !0 }), t.$scroll = i, t.magic("scroll", () => i);
}, $ = /* @__PURE__ */ Symbol("$slider"), fi = (t) => $ in t, ca = {
  ":disabled"() {
    return this[$].isLast;
  },
  "x-on:click"() {
    this[$].next(this.$el);
  }
}, ua = {
  ":disabled"() {
    return this[$].isFirst;
  },
  "x-on:click"() {
    this[$].prev(this.$el);
  }
}, da = (t) => ({
  ":disabled"() {
    return this[$].focusedIndex === t;
  },
  "x-on:click"() {
    this[$].scrollTo(t);
  }
}), fa = {
  "x-on:mouseenter"() {
    this[$].pause();
  },
  "x-on:mouseleave"() {
    this[$].unpause();
  },
  "x-on:focusin"() {
    this[$].pause();
  },
  "x-on:focusout"() {
    this[$].unpause();
  }
}, ha = { ":style"() {
  const t = this[$].focusedSize;
  return {
    maxHeight: t ? `${t}px` : "max-content",
    transition: "max-height 300ms"
  };
} }, pa = {
  "x-intersect.threshold.60"() {
    this.visible = !0;
    const t = this[$];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el);
  },
  "x-intersect:leave.threshold.40"() {
    this.visible = !1;
    const t = this[$];
    this.index = t.indexOfItem(this.$el) ?? 0, t.handleIntersect(this.$el, !1);
  },
  "x-init"() {
    this[$].onLoad(this.$el);
  },
  "x-on:load"() {
    this[$].onLoad(this.$el);
  },
  "x-data"() {
    return {
      visible: !1,
      index: 0
    };
  },
  ":class"() {
    const t = this[$], e = this.index, i = t.focusedIndex;
    return {
      "slide-item": !0,
      "slide-next": e > i,
      "slide-previous": e < i,
      "slide-current": e === i,
      "slide-visible": this.visible
    };
  }
}, va = {
  "x-intersect:enter.threshold.60"() {
    this.$el.removeAttribute("tabindex"), this.$el.removeAttribute("inert");
  },
  "x-intersect:leave.threshold.40"() {
    this.$el.setAttribute("tabindex", "-1"), this.$el.setAttribute("inert", "inert");
  }
}, ma = (t, e, i, { Alpine: n, cleanup: r }) => {
  const a = n.$data(e);
  if (!fi(a)) {
    console.error(`Element with ${i.original} needs to be inside an x-slider element`, e);
    return;
  }
  const s = a[$];
  if (s.components.set(t, e), t === "gallery") {
    const o = new AbortController();
    e.addEventListener("scroll", s.updateEdges.bind(s), {
      passive: !0,
      signal: o.signal
    }), r(() => o.abort()), s.updateEdges();
  }
}, et = (t) => Array.from(t.children).flatMap((e) => getComputedStyle(e).display === "contents" ? et(e) : e).filter((e) => e.nodeName !== "TEMPLATE" && getComputedStyle(e).display !== "none"), ga = (t, e) => {
  let i = 0, n = Number.POSITIVE_INFINITY;
  for (let r = 0; r < t.length; r++) {
    const a = Math.abs(t[r] - e);
    if (a >= n) return i;
    n = a, i = r;
  }
  return i;
}, ba = (t, e, i, n = 1) => {
  const r = e - i;
  return {
    atStart: t <= n,
    atEnd: t >= r - n
  };
}, ya = (t) => t instanceof HTMLImageElement, wa = (t, { expression: e }, { evaluate: i, cleanup: n, Alpine: r }) => {
  const a = [];
  n(() => a.forEach((l) => l()));
  const s = Object.assign({
    scrollToDepth: 0,
    intoView: !1,
    centerVertically: !1,
    autoScroll: 0,
    autoInitialize: !1,
    animated: !1
  }, e ? i(e) : {}), o = r.reactive({
    focusedIndex: 0,
    focusedSize: 0,
    initialized: !!s.autoInitialize,
    touched: !1,
    paused: !1,
    atStart: !0,
    atEnd: !1,
    pause() {
      return this.paused = !0, this;
    },
    unpause() {
      return this.paused = !1, this;
    },
    components: /* @__PURE__ */ new Map(),
    autoScrollPercentage: 1,
    init() {
      if (s.autoScroll) {
        const l = new xa(s.autoScroll).onTick((c) => {
          this.autoScrollPercentage = c;
        }).onFinish(() => {
          if (this.touched) return l.abort();
          if (this.paused) return;
          const c = this.components.get("gallery");
          c && this.scrollTo(Ni(this.focusedIndex + 1, et(c).length));
        });
        a.push(() => l.abort());
      }
    },
    onLoad(l) {
      if (this.initialized || ya(l) && !l.complete) return;
      this.focusedIndex = 0, this.focusedSize = this.itemAtIndex(0)?.clientHeight || 0;
      const c = this.components.get("gallery");
      c && (c.scrollLeft = 0), this.initialized = !0, this.init(), this.updateEdges();
    },
    handleIntersect(l, c = !0) {
      if (!this.initialized) return;
      const d = this.components.get("gallery");
      if (c && (!d || s.animated)) {
        this.focusedIndex = this.indexOfItem(l) ?? 0, this.focusedSize = l.clientHeight;
        return;
      }
      this.updateFocusedIndex(), this.updateEdges();
    },
    updateFocusedIndex() {
      const l = this.components.get("gallery");
      if (!l) return;
      const c = et(l), d = parseFloat(getComputedStyle(l).scrollPaddingLeft) || 0, u = c.map((v) => ot(HTMLElement, v)?.offsetLeft ?? 0), p = ga(u, l.scrollLeft + d);
      this.focusedIndex = p, this.focusedSize = ot(HTMLElement, c[p])?.clientHeight ?? t.clientHeight;
    },
    itemAtIndex(l) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = et(c);
      let u = d[ki(l, d.length - 1)];
      if (u !== void 0) {
        for (let p = 0; p < s.scrollToDepth; p++) u = u?.firstElementChild ?? u;
        return u?.closest("template") ? this.itemAtIndex(l + 1) : u;
      }
    },
    indexOfItem(l) {
      const c = this.components.get("gallery");
      if (!c) return;
      const d = et(c);
      for (let u = 0; u < d.length; u++) if (d[u].contains(l)) return u;
    },
    async scrollTo(l, c = 0, d = !1, u = !1) {
      const p = this.components.get("gallery");
      if (!p) return;
      const v = l instanceof Element ? l : this.itemAtIndex(l);
      if (!v) return;
      d && (this.touched = !0);
      const g = typeof l == "number" ? l : this.indexOfItem(v) ?? this.focusedIndex;
      this.initialized || (this.initialized = !0, await Ci()), u || s.animated ? this.focusedIndex = g : this.focusedIndex += Math.sign(g - this.focusedIndex), s.animated || (window.scrollBy({ top: 0.5 }), window.scrollBy({ top: -0.5 }), s.intoView ? v.scrollIntoView({
        behavior: "smooth",
        block: s.centerVertically ? "center" : "nearest",
        inline: "center"
      }) : (u && (p.style.scrollBehavior = "auto"), p.scrollLeft = l === 0 ? 0 : (ot(HTMLElement, v)?.offsetLeft ?? 0) - c, u && (p.style.scrollBehavior = null)));
      const y = this.components.get("thumbnails");
      if (!y) return;
      const m = ot(HTMLElement, y.children[g]);
      m && y.scrollTo({
        top: m.offsetTop - (y.clientHeight - m.clientHeight) / 2,
        left: m.offsetLeft - (y.clientWidth - m.clientWidth) / 2,
        behavior: "smooth"
      });
    },
    updateEdges() {
      const l = this.components.get("gallery");
      if (!l || s.animated) return;
      const { atStart: c, atEnd: d } = ba(l.scrollLeft, l.scrollWidth, l.clientWidth);
      this.atStart = c, this.atEnd = d;
    },
    get isFirst() {
      return s.animated ? this.focusedIndex === 0 : this.atStart;
    },
    get isLast() {
      const l = this.components.get("gallery");
      return l ? s.animated ? this.focusedIndex === et(l).length - 1 : this.atEnd : !0;
    },
    get itemCount() {
      const l = this.components.get("gallery");
      return l ? et(l).length : 0;
    },
    next(l) {
      const c = this.getStepInfo(l);
      this.scrollTo(Math.max(0, this.focusedIndex + c), 10, !0);
    },
    prev(l) {
      const c = this.getStepInfo(l);
      this.scrollTo(Math.max(0, this.focusedIndex - c), 10, !0);
    },
    getStepInfo(l) {
      const c = getComputedStyle(l);
      let d = parseInt(c.getPropertyValue("--perpage") || "1");
      const u = c.getPropertyValue("--arrow-step").trim(), p = this.components.get("gallery");
      if (p && u === "view") {
        const v = ot(HTMLElement, this.itemAtIndex(0)), g = ot(HTMLElement, this.itemAtIndex(1)), y = v && g && v !== g ? Math.abs(g.offsetLeft - v.offsetLeft) : 0;
        y > 0 && (d = Math.max(1, Math.floor(p.clientWidth / y)));
      }
      return d;
    }
  });
  r.addScopeToNode(t, { [$]: o }), s.autoInitialize && o.init();
}, xa = class hi extends EventTarget {
  duration = 0;
  currentTime = 0;
  lastTimestep = 0;
  controller = new AbortController();
  get percentage() {
    return this.currentTime / this.duration;
  }
  constructor(e) {
    super(), this.duration = e, this.lastTimestep = performance.now(), requestAnimationFrame(this.ticker);
  }
  ticker = (e) => {
    if (this.controller.signal.aborted) return;
    const i = e - this.lastTimestep;
    this.lastTimestep = e, this.currentTime += i, this.dispatchEvent(new Event("tick")), this.currentTime > this.duration && (this.dispatchEvent(new Event("just-finished")), this.currentTime %= this.duration), requestAnimationFrame(this.ticker);
  };
  abort() {
    this.controller.abort();
  }
  onTick(e) {
    return this.addEventListener("tick", () => e(this.percentage), { signal: this.controller.signal }), this;
  }
  onFinish(e) {
    return this.addEventListener("just-finished", e, { signal: this.controller.signal }), this;
  }
  static fromSeconds(e) {
    return new hi(e * 1e3);
  }
}, Ea = (t) => {
  t.addRootSelector(() => `[${t.prefixed("slider")}]`), t.directive("slider", (e, i, n) => {
    if (!i.value || i.value === "root") return wa(e, i, n);
    (i.value === "gallery" || i.value === "thumbnails") && ma(i.value, e, i, n);
  }), t.magic("slider", (e) => {
    const i = t.$data(e);
    if (fi(i)) return i[$];
  }), t.bind("$sliderDynamicHeight", ha), t.bind("$sliderItem", pa), t.bind("$sliderNext", ca), t.bind("$sliderPrev", ua), t.bind("$sliderGoTo", da), t.bind("$sliderPause", fa), t.bind("$sliderUnfocusHidden", va);
}, Ae = (t, e, i = e) => {
  const { scrollPaddingTop: n, scrollPaddingBottom: r } = window.getComputedStyle(t);
  return {
    top: Fe(n, e),
    bottom: Fe(r, i)
  };
}, Fe = (t, e) => t !== "auto" ? parseInt(t) : e, Sa = 100, Ta = (t) => {
  t.addRootSelector(() => `[${t.prefixed("smartstick")}]`), t.directive("smartstick", (e, i, { cleanup: n }) => {
    let r = Ae(e, Sa);
    const a = t.reactive({
      top: 0,
      get topString() {
        return `${-1 * this.top + r.top}px`;
      }
    });
    let s = 0, o = window.scrollY;
    const l = () => {
      const g = window.scrollY, y = g - o;
      a.top = Math.min(s, Math.max(0, a.top + y)), o = g;
    }, c = () => {
      r = Ae(e, r.top, r.bottom), s = Math.max(0, e.clientHeight - window.innerHeight + r.top + r.bottom);
    }, d = new ResizeObserver(c);
    d.observe(e), window.addEventListener("resize", c);
    const u = window.matchMedia("(min-width: 1024px)"), p = (g) => window[g.matches ? "addEventListener" : "removeEventListener"]("scroll", l, { passive: !0 });
    u.addEventListener("change", p), p(u);
    const v = t.effect(() => e.style.top = a.topString);
    n(() => {
      t.release(v), d.disconnect(), u.removeEventListener("change", p), window.removeEventListener("resize", c), window.removeEventListener("scroll", l);
    });
  });
}, se = (t, e, i) => {
  const n = /* @__PURE__ */ new WeakMap();
  return (r) => {
    r.addRootSelector(() => `[${r.prefixed(t)}]`);
    const a = (s) => {
      const o = r.findClosest(s, n.has.bind(n));
      if (!o) return console.error(`Could not find root for ${t} component`, s);
      if (o instanceof HTMLElement) return n.get(o);
    };
    r.magic(t, (s) => a(s)), r.directive(t, (s, o, l) => {
      if (!o.value) return n.set(s, e(s, o, l));
      const c = a(s);
      if (!c) return Ia(t, s);
      (i?.[o.value] || ka(t))(c, s, o, l);
    });
  };
}, ka = (t) => (e, i, n) => {
  console.error(`Alpine ${t}: Invalid directive value`, i, n.original);
}, Ia = (t, e) => console.error(`Could not find root for ${t} component`, e), Lt = /* @__PURE__ */ new WeakMap(), Ca = (t, e) => {
  const i = e.findClosest(t, Lt.has.bind(Lt));
  if (i instanceof HTMLElement) return Lt.get(i);
}, Na = (t, e, { Alpine: i, effect: n }) => {
  const r = i.reactive({
    active: null,
    id: 0,
    addAccordion(a) {
      const s = this.id++, o = i.reactive({ active: a });
      return n(() => {
        o.active ? this.active = s : this.active === s && (this.active = null);
      }), n(() => {
        this.active === s ? o.active = !0 : o.active = !1;
      }), o;
    }
  });
  return Lt.set(t, r), r;
}, Oa = (t) => {
  t.addRootSelector(() => `[${t.prefixed("accordion-group")}]`), t.directive("accordion-group", Na);
}, La = (t, { modifiers: [e = "closed"] }, { Alpine: i }) => Ca(t, i)?.addAccordion(e === "open") ?? i.reactive({ active: e === "open" }), _a = {
  open: !0,
  close: !1,
  toggle: null
}, Aa = (t, e, { modifiers: [i = "toggle"] }, { Alpine: n }) => {
  n.bind(e, {
    "x-on:click": () => {
      t.active = _a[i] ?? !t.active;
    },
    ":aria-expanded": () => t.active
  });
}, Fa = (t, e, i, { Alpine: n }) => {
  n.bind(e, { "x-show": () => t.active });
}, $a = {
  control: Aa,
  container: Fa
}, Ra = se("accordion", La, $a), Da = (t) => {
  Oa(t), Ra(t);
}, $e = new ResizeObserver((t) => {
  for (const e of t) {
    const i = e.target;
    i instanceof HTMLElement && Pa(i);
  }
}), Pa = async (t) => {
  await xt.nextTick(), t.scrollLeft = (t.scrollWidth - t.clientWidth) / 2, t.scrollTop = (t.scrollHeight - t.clientHeight) / 2;
}, Re = Array.prototype.forEach, Ma = (t) => t.directive("dragscroll", (e, { modifiers: i }, { cleanup: n }) => {
  const r = i.includes("center");
  n(ja(e)), e.classList.add("overscroll-contain", "cursor-grab"), r && (Re.call(e.children, (a) => $e.observe(a)), n(() => Re.call(e.children, (a) => $e.unobserve(a))));
}), pt = (t) => {
  t.preventDefault(), t.stopPropagation();
}, De = [
  "pointerup",
  "mouseup",
  "touchend"
], ja = (t) => {
  const e = (r) => {
    pt(r), t.scrollLeft -= r.movementX, t.scrollTop -= r.movementY;
  }, i = async (r) => {
    pt(r), document.removeEventListener("pointermove", e, !0), document.body.classList.remove("!cursor-grabbing", "[&>*]:pointer-events-none"), t.classList.add("cursor-grab"), await xt.nextTick(), document.removeEventListener("click", pt, !0), De.forEach((a) => document.removeEventListener(a, i, { capture: !0 }));
  }, n = (r) => {
    qa(r) || r.button !== 2 && (pt(r), t.classList.remove("cursor-grab"), document.body.classList.add("!cursor-grabbing", "[&>*]:pointer-events-none"), document.addEventListener("pointermove", e, { capture: !0 }), De.forEach((a) => document.addEventListener(a, i, { capture: !0 })), document.addEventListener("click", pt, { capture: !0 }));
  };
  return t.addEventListener("pointerdown", n), () => t.removeEventListener("pointerdown", n);
}, qa = (t) => t instanceof TouchEvent || t instanceof PointerEvent && t.pointerType === "touch", Ba = (t, e, { Alpine: i }) => {
  const n = i.reactive({
    root: t,
    isOpen: !1,
    open() {
      this.isOpen = !0;
    },
    close() {
      this.isOpen = !1;
    },
    toggle() {
      return this.isOpen ? this.close() : this.open();
    }
  });
  return i.bind(t, { "x-id": () => ["x-panel"] }), n;
}, Va = se("panel", Ba, {
  summary: (t, e, i, { Alpine: n }) => {
    n.bind(e, {
      ":aria-expanded": () => t.isOpen,
      ":aria-controls": '$id("x-panel")'
    });
  },
  content: (t, e, i, { Alpine: n }) => {
    n.bind(e, {
      "x-show": () => t.isOpen,
      ":id": '$id("x-panel")'
    });
  }
}), Ha = se("tabs", (t, e, { Alpine: i, evaluate: n }) => i.reactive({
  activeTab: 0,
  isSelected(r) {
    return this.tabs[this.activeTab] === r;
  },
  tabs: [],
  panels: [],
  $focus: n("$focus")
}), {
  list: (t, e, i, { Alpine: n }) => {
    const r = () => t.$focus.wrap().next(), a = () => t.$focus.wrap().previous();
    n.bind(e, {
      ":role": () => "tablist",
      "@keydown.arrow-left.stop.prevent": a,
      "@keydown.arrow-right.stop.prevent": r,
      "@keydown.arrow-up.stop.prevent": a,
      "@keydown.arrow-down.stop.prevent": r
    });
  },
  tab: (t, e, i, { Alpine: n }) => {
    const r = t.tabs.push(e) - 1, a = () => t.activeTab = r;
    n.bind(e, {
      ":tabindex": () => +(r === t.activeTab) - 1,
      ":aria-selected": () => r === t.activeTab,
      "@click": a,
      "@keydown.space.stop.prevent": a,
      "@keydown.enter.stop.prevent": a
    });
  },
  panel: (t, e, i, { Alpine: n }) => {
    const r = t.panels.push(e) - 1;
    n.bind(e, {
      ":tab-index": () => r !== t.activeTab ? -1 : 0,
      ":aria-hidden": () => r !== t.activeTab,
      ":class"() {
        if (r === t.activeTab) return "panel-current";
        if (r > t.activeTab) return "panel-next";
        if (r < t.activeTab) return "panel-previous";
      }
    });
  }
}), yt;
(function(t) {
  t[t.None = 0] = "None", t[t.Left = 1] = "Left", t[t.Right = 2] = "Right", t[t.Up = 4] = "Up", t[t.Down = 8] = "Down";
})(yt || (yt = {}));
var wt = /* @__PURE__ */ new WeakMap(), Ka = wt.has.bind(wt), za = (t) => t.directive("swipe", (e, i, { cleanup: n }) => {
  wt.set(e, { dispatch: (r) => {
    const a = Object.entries(yt).filter(([, s]) => typeof s == "number" && s && (r & s) === s).map(([s]) => s.toLowerCase());
    e.dispatchEvent(new CustomEvent("swipe", { detail: a.join("-") })), e.dispatchEvent(new CustomEvent(`swipe${a.join("")}`, { detail: a.join("-") }));
  } }), e.addEventListener("touchstart", Pe), n(() => e.removeEventListener("touchstart", Pe));
}), Pe = (t) => {
  const e = wt.get(t.currentTarget);
  if (!e) return;
  const { clientX: i, clientY: n } = t.touches[0];
  e.start ??= {
    x: i,
    y: n
  }, document.addEventListener("touchend", Wa, { once: !0 });
}, Wa = (t) => {
  const e = t.target;
  if (!e) return;
  const i = wt.get(pi(e, Ka));
  if (!i?.start) return;
  const { clientX: n, clientY: r } = t.changedTouches[0], a = Ua(i.start, {
    x: n,
    y: r
  });
  a !== yt.None && (i.dispatch(a), delete i.start);
}, pi = (t, e) => e(t) ? t : t.parentElement ? pi(t.parentElement, e) : null, Ua = (t, e) => {
  const i = [e.x - t.x, e.y - t.y];
  if (i.every((s) => Math.abs(s) < 50)) return yt.None;
  const n = Math.sqrt(i[0] * i[0] + i[1] * i[1]), [r, a] = i.map((s) => s / n);
  return Me(r) | Me(a) << 2;
}, Me = (t) => t > 0.5 ? 2 : t < -0.5 ? 1 : 0, Ga = (t) => {
  t.magic("screen", () => (e) => {
    const i = typeof e == "number" ? e : Ya[e] ?? Number(e);
    return i ? Ja(i, t).value : (console.error(`Invalid breakpoint: $screen(${JSON.stringify(e)})`), !1);
  });
}, Ya = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, vi = {}, Ja = (t, e) => vi[t] ?? Xa(t, e), Xa = (t, e) => {
  const i = window.matchMedia(`(min-width: ${t}px)`), n = e.reactive({ value: i.matches });
  return vi[t] = n, i.addEventListener("change", (r) => {
    n.value = r.matches;
  }), n;
}, Qa = (t) => t.plugin([Ga]), Za = (t) => t.plugin([
  Da,
  Ma,
  Va,
  za,
  Ha,
  Qa
]), ts = (t) => {
  t.magic("abortSignal", (e, { cleanup: i }) => {
    const n = new AbortController();
    return i(() => n.abort("Alpine Component has been Removed")), n.signal;
  });
}, es = (t) => {
  t.magic("dataset", (e) => e.dataset), t.magic("formatMoney", () => window.NewThink?.ACCESS_GATE_SHOW_PRICES === !1 ? () => "" : gi);
}, is = (t) => {
  t.bind("hideOverflow", {
    "x-data": "{ visible: true }",
    ":class": "{ 'pointer-events-none invisible': !visible }",
    "x-intersect:leave.threshold.99.margin.1000.0": "visible = false",
    "x-intersect:enter.threshold.99.margin.1000.0": "visible = true"
  });
}, ns = (t) => {
  t.directive("inert-trap", (e, { expression: i, modifiers: n }, { evaluateLater: r, effect: a }) => {
    const s = n.includes("retain"), o = n.includes("noscroll"), l = n.includes("return"), c = r(i), d = [];
    let u = null;
    a(() => {
      c((p) => {
        if (p) {
          u = document.activeElement;
          for (const v of rs(e, ...document.querySelectorAll("[role=alertdialog]"), s ? u?.closest("[data-retain-focus-from]") ?? u : null))
            v.setAttribute("inert", "inert"), d.push(v);
          o && (document.documentElement.style.setProperty("overflow", "hidden"), document.body.style.setProperty("overflow", "hidden"));
        } else {
          for (const v of d) v.removeAttribute("inert");
          d.length = 0, o && (document.documentElement.style.removeProperty("overflow"), document.body.style.removeProperty("overflow")), l && u && (u.focus(), u = null);
        }
      });
    });
  });
};
function rs(...t) {
  return t = t.filter((e) => e !== null), document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, (e) => {
    if (!(e instanceof HTMLElement) || e.matches("[inert] > *") || t.includes(e)) return NodeFilter.FILTER_REJECT;
    for (const i of t) if (e.contains(i)) return NodeFilter.FILTER_SKIP;
    return NodeFilter.FILTER_ACCEPT;
  });
}
TreeWalker.prototype[Symbol.iterator] ??= function* () {
  let t = this.nextNode();
  for (; t; )
    yield t, t = this.nextNode();
};
var as = (t) => {
  t.directive("highlight-scroll", (e, { expression: i }, { cleanup: n }) => {
    const r = i.trim();
    if (!r) {
      console.warn("Alpine.js: v-highlight-scroll requires a class name to highlight.");
      return;
    }
    const a = e.firstChild;
    if (!a || !(a instanceof Text)) {
      console.warn("Alpine.js: v-highlight-scroll requires a text node as the first child.");
      return;
    }
    const s = (a.textContent?.trim().split("") ?? []).map((c) => {
      const d = document.createElement("span");
      return d.textContent = c, d.classList.add(r), d;
    });
    a.replaceWith(...s);
    let o = -1;
    const l = setInterval(() => {
      o == -1 ? s.forEach((c) => c.classList.remove(r)) : s[o]?.classList.remove(r), o += 1, o %= s.length, s[o]?.classList.add(r);
    }, 500);
    n(() => clearInterval(l));
  }), t.addInitSelector(() => t.prefixed("highlight-scroll"));
}, ss = [
  ts,
  er,
  na,
  ra,
  nr,
  $r,
  oa,
  ns,
  Br,
  is,
  Gr,
  ea({
    shopify: !0,
    autoSize: !0
  }),
  as,
  Ea,
  Ta,
  la,
  Za,
  es
], os = (t) => t.store("mobileMenu", {
  visible: !1,
  show() {
    this.visible = !0;
  },
  hide() {
    this.visible = !1;
  },
  toggle() {
    this.visible = !this.visible;
  }
}), ls = (t) => t.store("modal", {
  isOpen: !1,
  open() {
    this.isOpen = !0;
  },
  close() {
    this.isOpen = !1;
  }
}), cs = [
  bi,
  os,
  ls,
  yi
];
xt.plugin([
  ...ss,
  ...cs,
  ...xn
]);
window.Alpine = xt;
var us = xt, vs = us;
export {
  vs as default
};
